import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import _28x151 from "./28x151.png";
import _28x152 from "./28x152.png";
import _28x153 from "./28x153.png";

const width = "100%";
const height = "auto";
const viewBox = "0 0 777 275";

const getDimensions = (size, sizes) => {
  if (
    size &&
    typeof size.width === "number" &&
    typeof size.height === "number"
  ) {
    return size;
  }
  return size && sizes[size] ? sizes[size] : { width, height };
};

const getCss = (size, sizes, fillColor, fillColorRule, noStyles) => {
  if (noStyles) {
    return "";
  }
  const dimensions = getDimensions(size, sizes);
  const fillRule =
    fillColor && fillColorRule ? `${fillColorRule}{ fill: ${fillColor}; }` : "";
  return css`
    width: ${dimensions.width};
    height: ${dimensions.height};
    ${fillRule};
  `;
};

const propsToCss = ({ size, sizes, fillColor, fillColorRule, noStyles }) =>
  getCss(size, sizes, fillColor, fillColorRule, noStyles);

const Image = styled.svg`
  ${propsToCss};
`;

const children = (
  <Fragment>
    <defs key="key-0">
      <linearGradient
        id="s-98a276cdc1-a"
        x1="-2467.54"
        x2="-2467.29"
        y1="321.8"
        y2="321.8"
        gradientTransform="matrix(-1 0 0 1 -2238.54 -239.04)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#595959" />
        <stop offset=".5" stopColor="#949494" />
        <stop offset="1" stopColor="#5c5c5c" />
      </linearGradient>
      <linearGradient
        id="s-98a276cdc1-h"
        x1="-2466.35"
        x2="-2466.1"
        y1="321.74"
        y2="321.74"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-i"
        x1="-2465.24"
        x2="-2464.99"
        y1="321.68"
        y2="321.68"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-j"
        x1="-2464.13"
        x2="-2463.88"
        y1="321.6"
        y2="321.6"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-k"
        x1="-2462.94"
        x2="-2462.69"
        y1="321.53"
        y2="321.53"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-l"
        x1="-2461.83"
        x2="-2461.58"
        y1="321.47"
        y2="321.47"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-m"
        x1="-2460.7"
        x2="-2460.45"
        y1="321.4"
        y2="321.4"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-n"
        x1="-2459.51"
        x2="-2459.26"
        y1="321.33"
        y2="321.33"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-o"
        x1="-2458.4"
        x2="-2458.15"
        y1="321.26"
        y2="321.26"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-p"
        x1="-2457.29"
        x2="-2457.04"
        y1="321.2"
        y2="321.2"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-q"
        x1="-2456.1"
        x2="-2455.85"
        y1="321.16"
        y2="321.16"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-r"
        x1="-2454.99"
        x2="-2454.74"
        y1="321.04"
        y2="321.04"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-s"
        x1="-2453.92"
        x2="-2453.67"
        y1="320.97"
        y2="320.97"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-t"
        x1="-2452.73"
        x2="-2452.48"
        y1="320.94"
        y2="320.94"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-u"
        x1="-2451.62"
        x2="-2451.37"
        y1="320.88"
        y2="320.88"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-v"
        x1="-2471.47"
        x2="-2455.19"
        y1="311"
        y2="311"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-w"
        x1="-2471.46"
        x2="-2455.18"
        y1="309.55"
        y2="309.55"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-x"
        x1="-2471.45"
        x2="-2455.18"
        y1="308.17"
        y2="308.17"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-y"
        x1="-2471.45"
        x2="-2455.17"
        y1="306.71"
        y2="306.71"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-z"
        x1="-2471.44"
        x2="-2455.17"
        y1="305.33"
        y2="305.33"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-A"
        x1="-2471.58"
        x2="-2455.3"
        y1="340.69"
        y2="340.69"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-B"
        x1="-2471.58"
        x2="-2455.3"
        y1="341.9"
        y2="341.9"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-C"
        x1="-2471.57"
        x2="-2455.29"
        y1="339.31"
        y2="339.31"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-D"
        x1="-2471.57"
        x2="-2455.29"
        y1="337.86"
        y2="337.86"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-E"
        x1="-2471.56"
        x2="-2455.28"
        y1="336.47"
        y2="336.47"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-F"
        x1="-2471.55"
        x2="-2455.28"
        y1="335.02"
        y2="335.02"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-G"
        x1="-2471.55"
        x2="-2455.27"
        y1="333.64"
        y2="333.64"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-H"
        x1="-2471.54"
        x2="-2455.27"
        y1="332.19"
        y2="332.19"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-I"
        x1="-2471.54"
        x2="-2455.26"
        y1="330.8"
        y2="330.8"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-J"
        x1="-2471.53"
        x2="-2455.26"
        y1="329.35"
        y2="329.35"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-K"
        x1="-2471.53"
        x2="-2455.25"
        y1="327.93"
        y2="327.93"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-L"
        x1="-2471.52"
        x2="-2455.25"
        y1="326.48"
        y2="326.48"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-M"
        x1="-2471.52"
        x2="-2455.24"
        y1="325.1"
        y2="325.1"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-N"
        x1="-2471.51"
        x2="-2455.24"
        y1="323.64"
        y2="323.64"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-O"
        x1="-2471.51"
        x2="-2455.23"
        y1="322.26"
        y2="322.26"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-P"
        x1="-2471.5"
        x2="-2455.22"
        y1="320.81"
        y2="320.81"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-Q"
        x1="-2471.5"
        x2="-2455.22"
        y1="319.43"
        y2="319.43"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-R"
        x1="-2471.49"
        x2="-2455.21"
        y1="317.97"
        y2="317.97"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-S"
        x1="-2471.49"
        x2="-2455.21"
        y1="316.59"
        y2="316.59"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-T"
        x1="-2471.48"
        x2="-2455.2"
        y1="315.14"
        y2="315.14"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-U"
        x1="-2471.48"
        x2="-2455.2"
        y1="313.75"
        y2="313.75"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-V"
        x1="-2471.47"
        x2="-2455.19"
        y1="312.3"
        y2="312.3"
        gradientTransform="matrix(-.99 0 0 1 -2225.53 -231.52)"
        xlinkHref="#s-98a276cdc1-a"
      />
      <linearGradient
        id="s-98a276cdc1-W"
        x1="211.34"
        x2="230.45"
        y1="81.73"
        y2="81.73"
        xlinkHref="#s-98a276cdc1-a"
      />
      <radialGradient
        id="s-98a276cdc1-X"
        cx="214.76"
        cy="78.48"
        r="1.36"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#999" />
        <stop offset="1" stopColor="#4d4d4d" />
      </radialGradient>
      <linearGradient
        id="s-98a276cdc1-Y"
        x1="325.83"
        x2="325.86"
        y1="317.62"
        y2="317.11"
        gradientTransform="matrix(1.11 .01 .01 1 -146.87 -240.56)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#4d4d4d" />
        <stop offset=".5" stopColor="#949494" />
        <stop offset="1" stopColor="#4d4d4d" />
      </linearGradient>
      <linearGradient
        id="s-98a276cdc1-Z"
        x1="1980.98"
        x2="1981.25"
        y1="738.24"
        y2="737.72"
        gradientTransform="rotate(-27.38 391.605 3461.088)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#d45a24" />
        <stop offset=".84" stopColor="#a2272d" />
      </linearGradient>
      <linearGradient
        id="s-98a276cdc1-aa"
        x1="737.75"
        x2="738.23"
        y1="1017.62"
        y2="1017.78"
        gradientTransform="matrix(-.28 -1.17 .81 -.19 -66.1 1371.56)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f15a24" />
        <stop offset=".83" stopColor="#a6272d" />
      </linearGradient>
      <linearGradient
        id="s-98a276cdc1-b"
        x1="548.58"
        x2="548.78"
        y1="311.21"
        y2="311.21"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#be1e2d" />
        <stop offset="1" stopColor="#ee4036" />
      </linearGradient>
      <linearGradient
        id="s-98a276cdc1-ab"
        x1="546.69"
        x2="557.63"
        y1="312.53"
        y2="312.53"
        xlinkHref="#s-98a276cdc1-b"
      />
      <linearGradient
        id="s-98a276cdc1-c"
        x1="-1634.38"
        x2="-1628.08"
        y1="338.17"
        y2="338.17"
        gradientTransform="matrix(-1 0 0 1 -1372.33 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".46" stopColor="#d45a24" />
        <stop offset="1" stopColor="#a2272d" />
      </linearGradient>
      <linearGradient
        id="s-98a276cdc1-d"
        x1="-1659.92"
        x2="-1658.35"
        y1="210.71"
        y2="210.71"
        gradientTransform="matrix(-.99 -.11 -.11 .99 -1367.89 -60.26)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".46" stopColor="#f15a24" />
        <stop offset="1" stopColor="#c1272d" />
      </linearGradient>
      <linearGradient
        id="s-98a276cdc1-ac"
        x1="257.43"
        x2="257.6"
        y1="338"
        y2="338"
        xlinkHref="#s-98a276cdc1-b"
      />
      <linearGradient
        id="s-98a276cdc1-ad"
        x1="255.76"
        x2="265.46"
        y1="339.12"
        y2="339.12"
        xlinkHref="#s-98a276cdc1-b"
      />
      <clipPath id="s-98a276cdc1-ae" transform="translate(-114.32 -239.04)">
        <path
          d="M835.88 358.63c0 .16 0 .32-.07.48h-.62c0-.16 0-.32.07-.48h.62z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-af" transform="translate(-114.32 -239.04)">
        <path
          d="M835.88 358.63h-.62c.06-.41.13-.81.21-1.17h.62c-.09.36-.09.76-.21 1.17z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-ag" transform="translate(-114.32 -239.04)">
        <path
          d="M835.61 359.83h-.44c.08-.57.16-1.14.26-1.66h.62c-.09.52-.18 1.09-.25 1.66h-.19z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-ah" transform="translate(-114.32 -239.04)">
        <path
          d="M836.11 357.86l-.06.31h-.62l.06-.31h.62z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-ai" transform="translate(-114.32 -239.04)">
        <path
          d="M836.48 356a9.54 9.54 0 0 0-.39 1.45h-.62a8.5 8.5 0 0 1 .39-1.45h.62z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-aj" transform="translate(-114.32 -239.04)">
        <path
          d="M836.78 355.88a5.52 5.52 0 0 0-.67 2h-.62a5.52 5.52 0 0 1 .67-2h.62z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-ak" transform="translate(-114.32 -239.04)">
        <path
          d="M836.48 356h-.62a2.38 2.38 0 0 1 .31-.62h.63a2.37 2.37 0 0 0-.32.62z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-al" transform="translate(-114.32 -239.04)">
        <path
          d="M836.8 355.39h-.63a.56.56 0 0 1 .31-.22h.62a.54.54 0 0 0-.3.22z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-am" transform="translate(-114.32 -239.04)">
        <path
          d="M836.78 355.88h-.62a.46.46 0 0 1 .36-.23h.62a.46.46 0 0 0-.36.23z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-an" transform="translate(-114.32 -239.04)">
        <path
          d="M836.52 356.09h.63c-.72 0-1.16 2.72-1.41 5.18h-.63c.26-2.46.7-5.18 1.41-5.18z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-ao" transform="translate(-114.32 -239.04)">
        <path
          d="M837.16 355.17z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-ap" transform="translate(-114.32 -239.04)">
        <path
          d="M837.15 356.09a.42.42 0 0 1 .27.13h-.62a.42.42 0 0 0-.28-.13z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-aq" transform="translate(-114.32 -239.04)">
        <path
          d="M836.52 355.65h.62a.46.46 0 0 1 .3.13h-.63a.44.44 0 0 0-.29-.13z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-ar" transform="translate(-114.32 -239.04)">
        <path
          d="M837.16 355.17a.42.42 0 0 1 .3.14h-.62a.45.45 0 0 0-.3-.14z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-as" transform="translate(-114.32 -239.04)">
        <path
          d="M837.16 355a.45.45 0 0 1 .31.14h-.62a.48.48 0 0 0-.32-.14z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-at" transform="translate(-114.32 -239.04)">
        <path
          d="M837.46 355.31a.58.58 0 0 1 .12.14H837a.4.4 0 0 0-.11-.14z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-au" transform="translate(-114.32 -239.04)">
        <path
          d="M837.78 355.65h-.62a1.62 1.62 0 0 0-.31-.56h.62a1.47 1.47 0 0 1 .31.56z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-av" transform="translate(-114.32 -239.04)">
        <path
          d="M837.68 355.64h-.62a1.6 1.6 0 0 0-.11-.19h.63a1.65 1.65 0 0 1 .1.19z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-aw" transform="translate(-114.32 -239.04)">
        <path
          d="M837.87 356.15h-.63a4.86 4.86 0 0 0-.18-.51h.62a4.69 4.69 0 0 1 .19.51z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-ax" transform="translate(-114.32 -239.04)">
        <path
          d="M838 356.26h-.62c-.06-.23-.13-.44-.19-.61h.62a5 5 0 0 1 .19.61z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-ay" transform="translate(-114.32 -239.04)">
        <path
          d="M836.8 356.22h.62c.68.6 1.36 5.65 1.55 11.47h-.62c-.2-5.82-.88-10.87-1.55-11.47z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-az" transform="translate(-114.32 -239.04)">
        <path
          d="M836.81 355.78h.63c.7.64 1.41 5.85 1.62 11.89h-.63c-.2-6.04-.91-11.25-1.62-11.89z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-aA" transform="translate(-114.32 -239.04)">
        <path
          d="M838.68 363.44h-.39c-.13-1.69-.29-3.21-.48-4.48h.63c.18 1.27.35 2.79.48 4.47h-.24z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-aB" transform="translate(-114.32 -239.04)">
        <path
          d="M838 356.26a22.36 22.36 0 0 1 .53 2.76h-.63a24.74 24.74 0 0 0-.52-2.76h.62z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-aC" transform="translate(-114.32 -239.04)">
        <path
          d="M837.87 356.15a21.07 21.07 0 0 1 .57 2.82h-.63a18.29 18.29 0 0 0-.57-2.82h.63z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-aD" transform="translate(-114.32 -239.04)">
        <path
          d="M838.88 362.44h-.63c-.11-1.26-.24-2.42-.38-3.42h.63c.14.98.27 2.16.38 3.42z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-aE" transform="translate(-114.32 -239.04)">
        <path
          d="M839 364.49h-.62c0-.71-.1-1.39-.16-2.05h.63c.09.66.15 1.34.15 2.05z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-aF" transform="translate(-114.32 -239.04)">
        <path
          d="M838.92 363.44c0 .43.06.86.09 1.31h-.63c0-.45-.06-.88-.09-1.31h.63z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-aG" transform="translate(-114.32 -239.04)">
        <path
          d="M839 364.49c0 .36.05.73.07 1.1h-.62c0-.37-.05-.74-.07-1.1z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-aH" transform="translate(-114.32 -239.04)">
        <path
          d="M839.06 365.6h-.63v-.85h.57c0 .25 0 .56.06.85z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-aI" transform="translate(-114.32 -239.04)">
        <path
          d="M839.1 366.38v1.45h-.62c0-.49 0-1-.06-1.45h.63z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-aJ" transform="translate(-114.32 -239.04)">
        <path
          d="M839.1 365.59c0 .73.07 1.47.1 2.23h-.63c0-.76-.05-1.5-.09-2.23z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <clipPath id="s-98a276cdc1-aK" transform="translate(-114.32 -239.04)">
        <path
          d="M839.06 365.6v.78h-.63v-.78h.63z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <linearGradient
        id="s-98a276cdc1-aL"
        x1="-224.83"
        x2="-217.88"
        y1="373.58"
        y2="373.58"
        gradientTransform="translate(1054.45)"
        xlinkHref="#s-98a276cdc1-c"
      />
      <linearGradient
        id="s-98a276cdc1-aM"
        x1="-1152.32"
        x2="-1152.13"
        y1="372.24"
        y2="372.24"
        gradientTransform="matrix(-1 0 0 1 -317.87 0)"
        xlinkHref="#s-98a276cdc1-b"
      />
      <linearGradient
        id="s-98a276cdc1-aN"
        x1="-1154.26"
        x2="-1143.04"
        y1="373.53"
        y2="373.53"
        gradientTransform="matrix(-1 0 0 1 -317.87 0)"
        xlinkHref="#s-98a276cdc1-b"
      />
      <linearGradient
        id="s-98a276cdc1-aO"
        x1="-266.47"
        x2="-261.62"
        y1="408.34"
        y2="408.34"
        gradientTransform="rotate(-6.6 2.46 -9135.46)"
        xlinkHref="#s-98a276cdc1-d"
      />
      <linearGradient
        id="s-98a276cdc1-e"
        x1="433.99"
        x2="436.49"
        y1="119.78"
        y2="119.78"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#333" />
        <stop offset=".51" stopColor="#999" />
        <stop offset="1" stopColor="#333" />
      </linearGradient>
      <linearGradient
        id="s-98a276cdc1-f"
        x1="391.94"
        x2="431.1"
        y1="139.36"
        y2="139.36"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#e6e6e6" />
        <stop offset="1" stopColor="#f2f2f2" />
      </linearGradient>
      <linearGradient
        id="s-98a276cdc1-aP"
        x1="383.32"
        x2="385.82"
        y1="187.63"
        y2="187.63"
        xlinkHref="#s-98a276cdc1-e"
      />
      <linearGradient
        id="s-98a276cdc1-aQ"
        x1="379.33"
        x2="380.33"
        y1="203.16"
        y2="203.16"
        xlinkHref="#s-98a276cdc1-f"
      />
      <linearGradient
        id="s-98a276cdc1-aR"
        x1="436.44"
        x2="437.44"
        y1="119.45"
        y2="119.45"
        xlinkHref="#s-98a276cdc1-f"
      />
      <linearGradient
        id="s-98a276cdc1-aS"
        x1="373.43"
        x2="441.98"
        y1="162.46"
        y2="162.46"
        xlinkHref="#s-98a276cdc1-f"
      />
      <linearGradient
        id="s-98a276cdc1-aT"
        x1="372.68"
        x2="375.18"
        y1="213.41"
        y2="213.41"
        xlinkHref="#s-98a276cdc1-e"
      />
      <linearGradient
        id="s-98a276cdc1-aU"
        x1="440.23"
        x2="442.73"
        y1="113.89"
        y2="113.89"
        xlinkHref="#s-98a276cdc1-e"
      />
      <linearGradient
        id="s-98a276cdc1-g"
        x1="276"
        x2="276"
        y1="381.08"
        y2="395.81"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#c1272d" />
        <stop offset=".53" stopColor="#c6594b" />
        <stop offset="1" stopColor="#c1272d" />
      </linearGradient>
      <linearGradient
        id="s-98a276cdc1-aV"
        x1="259.81"
        x2="292.68"
        y1="387.86"
        y2="387.86"
        xlinkHref="#s-98a276cdc1-g"
      />
      <linearGradient
        id="s-98a276cdc1-aW"
        x1="281.54"
        x2="292.5"
        y1="370.86"
        y2="370.86"
        xlinkHref="#s-98a276cdc1-g"
      />
      <linearGradient
        id="s-98a276cdc1-aX"
        x1="260.7"
        x2="271.66"
        y1="383.19"
        y2="383.19"
        xlinkHref="#s-98a276cdc1-g"
      />
      <linearGradient
        id="s-98a276cdc1-aY"
        x1="270.79"
        x2="293.11"
        y1="377.64"
        y2="377.64"
        xlinkHref="#s-98a276cdc1-g"
      />
      <linearGradient
        id="s-98a276cdc1-aZ"
        x1="271.73"
        x2="293.12"
        y1="378.03"
        y2="378.03"
        xlinkHref="#s-98a276cdc1-g"
      />
      <linearGradient
        id="s-98a276cdc1-ba"
        x1="-1241.88"
        x2="-1241.88"
        y1="415.07"
        y2="435.53"
        gradientTransform="matrix(-1 0 0 1 -533.26 -239.04)"
        xlinkHref="#s-98a276cdc1-g"
      />
      <linearGradient
        id="s-98a276cdc1-bb"
        x1="-1250"
        x2="-1233.3"
        y1="424.56"
        y2="424.56"
        gradientTransform="matrix(-1 0 0 1 -533.26 -239.04)"
        xlinkHref="#s-98a276cdc1-g"
      />
      <linearGradient
        id="s-98a276cdc1-bc"
        x1="814.04"
        x2="824.49"
        y1="405.53"
        y2="405.53"
        xlinkHref="#s-98a276cdc1-g"
      />
      <linearGradient
        id="s-98a276cdc1-bd"
        x1="820.57"
        x2="830.73"
        y1="424.13"
        y2="424.13"
        xlinkHref="#s-98a276cdc1-g"
      />
      <linearGradient
        id="s-98a276cdc1-be"
        x1="813.89"
        x2="820.89"
        y1="415.28"
        y2="415.28"
        xlinkHref="#s-98a276cdc1-g"
      />
    </defs>
    <g id="surface">
      <g id="mainSurface">
        <path
          d="M776.23 274.29L1.61 215.11 195.83 99.64l527.14 29.61 53.26 145.04z"
          style={{
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M757.92 263.72L31.29 208.94 203.76 106l511.4 29.43 42.76 128.29z"
          style={{
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M363.7 242.86l86.86-128.88"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
      </g>
      <path
        className="tennisLines"
        d="M704.05 240.52L99.23 196.15l112.88-78.78 474.62 28.47 17.32 94.68z"
      />
      <path
        className="volleyballLines"
        d="M624.53 219.12L187.3 187.91l62.33-53.92 372.11 23.7 2.79 61.43z"
      />
      <g id="surfaceBasket" className="basketballTwo">
        <path d="M215.84 166.98l-104.28-6.06 38.95-23.24 96.37 6.09-31.04 23.21zM737.84 203.7l-127.33-8.62v-28.07l117.34 6.71 9.99 29.98z" />
      </g>
      <path
        id="surfaceBasketAcross"
        className="basketballOne"
        d="M468.52 152.26l-83.95-4.24 23.83-30.18 76.64 4.31-16.52 30.11z"
      />
    </g>
    <g id="lines">
      <g className="tennisLines">
        <path
          d="M704.05 240.52L99.23 196.15l112.88-78.78 474.62 28.47 17.32 94.68zM205.17 122.83l482.75 29.55M109.37 188.54l594.45 42.85M216.2 204.73l85.58-81.98M386.95 208.21l48.21-71.35M585.87 146.14l-14.27 75.71M264.48 158.48l315.06 19.43"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
      </g>
      <g className="volleyballLines">
        <path
          d="M624.53 219.12L187.3 187.91l62.33-53.92 372.11 23.7 2.79 61.43zM323.37 197.63l46.67-56.68M391.72 202.5l38.88-57.43M469.37 208.04l28.02-58.58"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
      </g>
      <g id="basketballLines" className="basketballTwo">
        <ellipse
          cx="348.99"
          cy="394.46"
          rx="38.68"
          ry="11.48"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
          transform="rotate(-4.71 -2614.249 1664.935)"
        />
        <path
          d="M215.84 166.98l-104.28-6.06 38.95-23.24 96.37 6.09-31.04 23.21z"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M302.73 354.09c40.91-2.84 117.63 16.39 83 41.12C327.21 437 210.38 433.15 177.28 429"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <ellipse
          cx="721.9"
          cy="419.87"
          rx="14"
          ry="40.9"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
          transform="rotate(-86 534.68 360.892)"
        />
        <path
          d="M833 385.39c-104.71-6.73-153.29 12.21-152.81 31.87.62 25.48 59.25 55.95 184.87 64.31"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M737.84 203.7l-127.33-8.62v-28.07l117.34 6.71 9.99 29.98z"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
      </g>
      <g id="basketAcrossLines" className="basketballOne">
        <path
          d="M446.61 352.76C385.16 410.94 679.89 425 690 366.46"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M468.52 152.26l-83.95-4.24 23.83-30.18 76.64 4.31-16.52 30.11z"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M582.84 391.3c-5.72 7.14-21.21 12.2-41.71 11.87-23.34-.38-45.9-5.87-42.27-16.39"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
          transform="translate(-114.32 -239.04)"
        />
      </g>
    </g>
    <image
      id="high"
      width="3160"
      height="1100"
      transform="translate(16.24) scale(.24)"
      xlinkHref={_28x151}
    />
    <image
      id="medium"
      width="3170"
      height="1029"
      transform="matrix(.24 0 0 .24 15.76 19.2)"
      xlinkHref={_28x152}
    />
    <image
      id="small"
      width="3182"
      height="972"
      transform="matrix(.24 0 0 .24 8.56 32.16)"
      xlinkHref={_28x153}
    />
    <g id="wicket">
      <path
        d="M229.95 101.53l-18.11-1.03V62.06l18.11 1.05v38.42z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M229.72 73.23l-.85-.07V69.8l.85.06v3.37zM229.72 94.52l-.85-.07v-3.36l.85.07v3.36z"
        style={{
          fill: "#999",
        }}
      />
      <path
        d="M228.87 64.59v36.33"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-a)",
        }}
      />
      <path
        d="M227.68 64.52v36.36"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-h)",
        }}
      />
      <path
        d="M226.57 64.47v36.35"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-i)",
        }}
      />
      <path
        d="M225.46 64.35v36.42"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-j)",
        }}
      />
      <path
        d="M224.27 64.29v36.41"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-k)",
        }}
      />
      <path
        d="M223.16 64.22v36.41"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-l)",
        }}
      />
      <path
        d="M222.04 64.16v36.4"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-m)",
        }}
      />
      <path
        d="M220.85 64.07v36.43"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-n)",
        }}
      />
      <path
        d="M219.74 64.01v36.42"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-o)",
        }}
      />
      <path
        d="M218.63 63.95v36.43"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-p)",
        }}
      />
      <path
        d="M217.44 63.95v36.34"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-q)",
        }}
      />
      <path
        d="M216.33 63.8v36.4"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-r)",
        }}
      />
      <path
        d="M215.25 63.76v36.34"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-s)",
        }}
      />
      <path
        d="M214.06 63.7v36.4"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-t)",
        }}
      />
      <path
        d="M212.95 63.63v36.41"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-u)",
        }}
      />
      <path
        d="M228.87 70.19l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-v)",
        }}
      />
      <path
        d="M228.87 68.74l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-w)",
        }}
      />
      <path
        d="M228.87 67.36l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-x)",
        }}
      />
      <path
        d="M228.87 65.91l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-y)",
        }}
      />
      <path
        d="M228.87 64.53l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-z)",
        }}
      />
      <path
        d="M228.87 99.82l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-A)",
        }}
      />
      <path
        d="M228.87 101.02l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-B)",
        }}
      />
      <path
        d="M228.87 98.44l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-C)",
        }}
      />
      <path
        d="M228.87 96.99l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-D)",
        }}
      />
      <path
        d="M228.87 95.61l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-E)",
        }}
      />
      <path
        d="M228.87 94.16l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-F)",
        }}
      />
      <path
        d="M228.87 92.78l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-G)",
        }}
      />
      <path
        d="M228.87 91.33l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-H)",
        }}
      />
      <path
        d="M228.87 89.95l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-I)",
        }}
      />
      <path
        d="M228.87 88.5l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-J)",
        }}
      />
      <path
        d="M228.87 87.09l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-K)",
        }}
      />
      <path
        d="M228.87 85.64l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-L)",
        }}
      />
      <path
        d="M228.87 84.26l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-M)",
        }}
      />
      <path
        d="M228.87 82.81l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-N)",
        }}
      />
      <path
        d="M228.87 81.43l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-O)",
        }}
      />
      <path
        d="M228.87 79.98l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-P)",
        }}
      />
      <path
        d="M228.87 78.6l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-Q)",
        }}
      />
      <path
        d="M228.87 77.15l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-R)",
        }}
      />
      <path
        d="M228.87 75.77l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-S)",
        }}
      />
      <path
        d="M228.87 74.32l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-T)",
        }}
      />
      <path
        d="M228.87 72.94L212.95 72"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-U)",
        }}
      />
      <path
        d="M228.87 71.49l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-98a276cdc1-V)",
        }}
      />
      <path
        d="M211.84 100.3V62.12l18.11 1.04v38.19"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "url(#s-98a276cdc1-W)",
        }}
      />
      <circle
        cx="214.76"
        cy="78.48"
        r="1.36"
        style={{
          fill: "url(#s-98a276cdc1-X)",
        }}
      />
      <path
        d="M214.76 78.48l3.45.16"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".5px",
          stroke: "url(#s-98a276cdc1-Y)",
        }}
      />
    </g>
    <g id="basketballAcross" className="basketballOne">
      <path
        d="M445.48 122.36l-2.53-.16V68.03l2.53-.01v54.34z"
        style={{
          fill: "#666",
        }}
      />
      <path
        d="M445.48 122.36l1.26-.71V67.61l-1.26.41v54.34z"
        style={{
          fill: "#333",
        }}
      />
      <path
        d="M446.74 67.61l-1.26.41h-3.23l2.25-.5 2.24.09z"
        style={{
          fill: "#858589",
        }}
      />
      <path
        d="M445.15 87.74l-2.2-.18-3.89-17.2 2.21.18 3.88 17.2z"
        style={{
          fill: "#4d4d4d",
        }}
      />
      <path
        d="M445.15 82.14l.01 5.6-3.88-17.2h-2.45l1.18-1.21h2.25l2.89 12.81z"
        style={{
          fill: "#333",
        }}
      />
      <path
        d="M570.31 299.4c-1.7-5.75-7.8-10-15.09-10s-12.63 2.59-14.32 8.34v7.35l7.08 7.47 14.67.85 7.6-6.63v-.09z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M562.72 313.5l-14.72-.86-7.13-7.54v-7.4c1.62-5.5 6.61-8.42 14.42-8.42 7.19 0 13.44 4.15 15.19 10.09v7.45zm-14.66-1.06l14.59.85 7.54-6.59v-7.24c-1.73-5.85-7.89-9.93-15-9.93-7.71 0-12.62 2.86-14.22 8.26v7.27z"
        style={{
          fill: "#1a1a1a",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M562 312.76l-13.76-.8-6.69-7.07v-6.95c1.52-5.18 6.18-7.91 13.48-7.91 6.72 0 12.55 3.88 14.19 9.44v7.02l-.09.15zm-13.48-1.4l13.26.77 6.81-5.88v-6.65c-1.58-5.27-7.16-9-13.59-9-4.87 0-11 1.29-12.88 7.42v6.61z"
        style={{
          fill: "#1a1a1a",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M441.86 73.35l-2.99-.18v-2.81l2.99.16v2.83z"
        style={{
          fill: "#c1272d",
        }}
      />
      <path
        d="M560.43 310.09l-11.07-.62v-9.16l11.07.61zm-10.33-1.32l9.58.53v-7.68l-9.58-.52z"
        style={{
          fill: "#1a1a1a",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M555 310.51a3.64 3.64 0 0 0-1.39-.3 5 5 0 0 0-1.64.1l1.2-.92 3 .17z"
        style={{
          fill: "#ea371f",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M554.27 311.86l-7 .28a.14.14 0 0 1-.19-.09.16.16 0 0 1 .1-.2l7-.28a.15.15 0 0 1 .19.1.14.14 0 0 1-.1.19z"
        style={{
          fill: "url(#s-98a276cdc1-Z)",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M557.47 312.46a.24.24 0 0 1 0 .17.11.11 0 0 1-.2 0l-2.5-.76a.31.31 0 0 1 0-.29.11.11 0 0 1 .2 0l2.5.77a.37.37 0 0 1 0 .11z"
        style={{
          fill: "url(#s-98a276cdc1-aa)",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M547.72 314.66a6.6 6.6 0 0 1-.17-.77l-.21-.15c.11.31.24.62.38.92zM548.56 314.89c.15.3.3.6.46.89a6.05 6.05 0 0 1-.49-1.41l-.17-.06c.06.19.13.39.2.58zM553.81 317.39c.21-.24.42-.47.62-.72a12.74 12.74 0 0 0-.22-1.26c0-.05 0-.09-.05-.13-.23.35-.48.69-.73 1 .08.25.16.5.25.75s.08.23.13.36zM549.59 313.17c.09.37.18.74.28 1.11.22 0 .46.08.7.1 0-.8.06-1.6.12-2.4a3.8 3.8 0 0 1 .16-1.28 9.4 9.4 0 0 0-2 .44 4.86 4.86 0 0 1 .74 2.03zM549.12 315.72a6.32 6.32 0 0 0 1 1.4 2.29 2.29 0 0 0 .12-.37c0-.15.07-.29.1-.44-.15-.39-.29-.79-.41-1.19a3.46 3.46 0 0 1-.29-.45 8.05 8.05 0 0 1-1-.25 5.44 5.44 0 0 0 .48 1.3zM554.28 315.08a8.21 8.21 0 0 1 .3 1.41v-.07q.12-.93.15-1.86l-.2.05zM551.83 313.43c0-.35-.08-.7-.13-1.06a5.83 5.83 0 0 0-.2-1.24c0-.1-.13-.3-.23-.33s-.27.23-.32.39a6.5 6.5 0 0 0-.1 1.09c0 .65-.05 1.38-.09 2.12a10.78 10.78 0 0 0 1.16.05c-.03-.34-.05-.68-.09-1.02zM552.12 314.89a2.45 2.45 0 0 0 0 .27c0-.09.07-.18.11-.28h-.13zM554.84 316.13a2 2 0 0 0 .55-1.75l-.43.13q-.03.81-.12 1.62zM554.2 314.84l.12-.19h-.14a.77.77 0 0 0 .02.19zM552 315.46v-.57h-.38c.08.18.22.37.38.57zM550.08 315c.13.16.26.33.38.5 0-.23 0-.47.07-.71l-.53-.07c0 .11.05.21.08.28zM550.65 315.77l.38.51.35.46.43-.86c0-.06.05-.11.07-.16-.16-.28-.32-.56-.45-.84l-.69-.05c-.02.32-.05.63-.09.94zM552.15 315.54a1.69 1.69 0 0 1 0 .23c.21.35.41.71.59 1.06l.5-.63c-.15-.45-.3-.89-.43-1.34h-.39c-.08.24-.17.46-.27.68zM555.55 314.73c.06-.15.1-.3.15-.46l-.14.05c0 .14 0 .27-.01.41zM553.35 316.06c.26-.34.51-.69.74-1a2.82 2.82 0 0 1-.07-.31 12 12 0 0 1-1.11.14c.16.36.31.76.44 1.17zM554.12 314.26l.52-.11c.13-.23.26-.46.38-.69a15.23 15.23 0 0 1 1-2.21 7.46 7.46 0 0 0-2-.55v.28c.11 1.09-.02 2.2.1 3.28zM557.19 312.41c0-.36-.32-.72-.87-1a9.53 9.53 0 0 1-.28 2.27c.74-.39 1.16-.84 1.15-1.27zM548 315.29c.22.39.46.78.71 1.17h.06v.12c.26.39.55.78.84 1.15l.11.15c.06-.13.12-.27.17-.4a10.48 10.48 0 0 1-1.14-1.67 8.71 8.71 0 0 1-.67-1.58 3.2 3.2 0 0 1-.37-.19c.12.4.22.82.29 1.25zM547.67 313.45a1.84 1.84 0 0 0 .31.2c-.15-.47-.28-.94-.39-1.42a7 7 0 0 0 .08 1.22z"
        style={{
          fill: "none",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M552.09 314.45h.33c.09-.25.17-.51.24-.77.18-.67.29-1.36.49-2a4.15 4.15 0 0 1 .35-1 12.19 12.19 0 0 0-1.38 0h-.69a4.39 4.39 0 0 1 .48 1.94c.09.58.14 1.21.18 1.83zM553.88 311.78a4.35 4.35 0 0 0 0-.89c-.11-.41-.18-.06-.26.12a5.1 5.1 0 0 0-.19.5c-.2.6-.31 1.22-.45 1.83a9.21 9.21 0 0 1-.33 1.09 11 11 0 0 0 1.35-.14 21 21 0 0 1-.12-2.51zM548.45 313.88a9.22 9.22 0 0 1 0-2.57 3.65 3.65 0 0 0-.84.5c.15.65.33 1.3.53 1.94zM555.13 316.9c.18-.36.34-.73.49-1.1a13 13 0 0 0 .4-1.66l-.11.05a6.48 6.48 0 0 1-.42 1.12 10.76 10.76 0 0 1-.36 1.59z"
        style={{
          fill: "none",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M435.48 75.66z"
        style={{
          fill: "none",
        }}
      />
      <path
        d="M555.91 315.41c0 .18-.11.36-.16.54a10.16 10.16 0 0 0 1.07-2.26 5 5 0 0 1-.48.3 14 14 0 0 1-.43 1.42zM556.18 311.32a6.71 6.71 0 0 0-.53 1.23A13.12 13.12 0 0 1 555 314a.75.75 0 0 1-.07.12 6.43 6.43 0 0 0 1-.34 9.52 9.52 0 0 0 .25-2.46zM551.6 318.21c.12-.13.23-.27.35-.41-.18-.26-.37-.51-.56-.76-.08.16-.17.32-.26.48.15.24.3.48.47.69zM554.8 316.45c0 .3-.08.61-.14.92.08-.08.15-.16.23-.23.14-.45.26-.91.36-1.37a8 8 0 0 1-.45.68zM553.87 317.55c0 .16.11.31.16.47l.42-.44v-.15-.54c-.18.23-.38.45-.58.66zM548.5 312.67a7.61 7.61 0 0 0 .07 1.26 7.37 7.37 0 0 0 1.11.31c-.17-.64-.32-1.28-.47-1.92 0-.16-.19-1-.43-1.13l-.2.07a5.66 5.66 0 0 0-.06.84c-.01.19-.02.38-.02.57zM552.17 316.19v1.36l.47-.58c-.15-.26-.31-.52-.47-.78zM551.29 316.9l-.4-.54-.28-.34-.06.36a7.6 7.6 0 0 0 .49 1c.09-.16.17-.32.25-.48zM547.46 312a1 1 0 0 0-.32.67.91.91 0 0 0 .33.64 9.57 9.57 0 0 1-.01-1.31zM552 315.89c-.16.32-.33.65-.5 1 .17.22.34.45.5.68v-1.68zM553.32 317.89l.38-.39-.15-.45c-.08-.21-.15-.43-.23-.64l-.47.61c0 .08.09.16.13.24zM550.43 315.78a2.11 2.11 0 0 1-.19-.23l.15.44a1.55 1.55 0 0 0 .04-.21zM550.93 317.56l-.14-.25c-.11-.21-.21-.43-.31-.64-.05.22-.12.43-.19.64.16.18.33.35.49.51zM550.06 317.28a8.45 8.45 0 0 1-.53-.69 7.3 7.3 0 0 0 .52.72z"
        style={{
          fill: "none",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M548.45 313.88l.12.05a7.61 7.61 0 0 1-.07-1.26v-.57a5.66 5.66 0 0 1 .06-.84l-.1.05a9.22 9.22 0 0 0-.01 2.57zM550.57 314.38h.19c0-.74 0-1.47.09-2.12a6.5 6.5 0 0 1 .1-1.09c0-.16.12-.44.32-.39s.19.23.23.33a5.83 5.83 0 0 1 .2 1.24c0 .36.09.71.13 1.06s.06.68.09 1h.17c0-.62-.1-1.25-.18-1.87a4.39 4.39 0 0 0-.48-1.94l-.58.06a3.8 3.8 0 0 0-.16 1.28c-.06.84-.07 1.64-.12 2.44zM547.67 313.45a7 7 0 0 1-.08-1.22c.11.48.24.95.39 1.42l.19.1c-.2-.64-.38-1.29-.53-1.94l-.18.16a9.57 9.57 0 0 0 0 1.31zM548.56 310.8a.17.17 0 0 0-.12.06l.13-.06zM549.21 312.32c.15.64.3 1.28.47 1.92h.19c-.1-.37-.19-.74-.28-1.11a4.86 4.86 0 0 0-.69-2l-.12.05c.22.16.39.98.43 1.14z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M555.75 316c0-.18.11-.36.16-.54a14 14 0 0 0 .41-1.4l-.32.15a13 13 0 0 1-.4 1.66c-.15.37-.31.74-.49 1.1a10.76 10.76 0 0 0 .36-1.59 6.48 6.48 0 0 0 .42-1.12l-.21.08c-.05.16-.09.31-.15.46v-.41l-.17.06a2 2 0 0 1-.55 1.75q.09-.81.12-1.62l-.18.05q0 .93-.15 1.86v.07a8.21 8.21 0 0 0-.3-1.41l.3-.47-.26.05-.12.19a.77.77 0 0 1 0-.15h-.16a2.82 2.82 0 0 0 .07.31c-.23.35-.48.7-.74 1-.13-.41-.28-.81-.44-1.21h-.09c.13.45.28.89.43 1.34l-.5.63c-.18-.35-.38-.71-.59-1.06a1.69 1.69 0 0 0 0-.23c.1-.22.19-.44.28-.66h-.18c0 .1-.07.19-.11.28a2.45 2.45 0 0 1 0-.27h-.18v.57c-.13-.2-.27-.39-.41-.58h-.13c.13.28.29.56.45.84 0 0 0 .1-.07.16l-.43.86-.35-.46-.38-.51c0-.31.07-.62.09-.94h-.21c0 .24 0 .48-.07.71-.12-.17-.25-.34-.38-.5s-.06-.19-.08-.28h-.37a3.46 3.46 0 0 0 .29.45c.12.4.26.8.41 1.19 0 .15-.06.29-.1.44a2.29 2.29 0 0 1-.12.37 6.32 6.32 0 0 1-1-1.4 5.44 5.44 0 0 1-.46-1.3l-.13-.05a6.05 6.05 0 0 0 .49 1.41c-.16-.29-.31-.59-.46-.89s-.14-.39-.2-.58l-.23-.1a8.71 8.71 0 0 0 .67 1.58 10.48 10.48 0 0 0 1.17 1.61c-.05.13-.11.27-.17.4l-.11-.15c-.29-.37-.58-.76-.84-1.15v-.12h-.06c-.25-.39-.49-.78-.71-1.17s-.21-.85-.28-1.27a1.07 1.07 0 0 1-.21-.13 6.6 6.6 0 0 0 .17.77c-.14-.3-.27-.61-.38-.92l-.18-.15a11.53 11.53 0 0 0 1.68 3.27c.12.44.26.87.41 1.29v.71a12.75 12.75 0 0 1-.1 1.85 2.77 2.77 0 0 0 0 .42c-.1.48-.36 1.88.31 1.39h.06a.71.71 0 0 0 .36.29.56.56 0 0 0 .59-.18c.15.27.36.53.65.51a.58.58 0 0 0 .42-.29l.1-.16a.74.74 0 0 0 1 .19 1.27 1.27 0 0 0 .33-.36.8.8 0 0 0 .2.21c.4.29.58-.16.66-.48a.5.5 0 0 0 0-.12l.21.39a.08.08 0 0 0 .15 0 7.88 7.88 0 0 0 .11-2.06 5.54 5.54 0 0 1 .1-1 .06.06 0 0 0 0-.07c.07-.33.15-.65.24-1a1.09 1.09 0 0 0 .08-.15 11.51 11.51 0 0 0 .63-1.33.07.07 0 0 0 0-.06l.06-.13a12.89 12.89 0 0 0 1.58-3.2 2.43 2.43 0 0 1-.25.2 10.16 10.16 0 0 1-1.06 2.26zm-1.59-.7s0 .08.05.13a12.74 12.74 0 0 1 .22 1.26c-.2.25-.41.48-.62.72 0-.13-.09-.25-.13-.37s-.17-.5-.25-.75c.25-.35.5-.69.73-1.04zm-4.68 3.49c.08.2.16.39.25.58l-.24.26c0-.24-.07-.49-.1-.74zm-.1 0v-.33l.09.22zm.42.75c.09.17.17.35.26.52l-.37.45c-.07-.24-.12-.47-.17-.71zm1.87-.5l-.23-.21zm-.11-.36l.08-.1c.14.18.3.36.45.53l-.08.08zm.25.7l-.49.48-.37-.46.39-.45zm-.42-.88c-.16-.17-.32-.34-.49-.5l.13-.24a7.17 7.17 0 0 0 .45.63zm-.11.13l-.09-.09-.38-.37zm-.13.15l-.36.42-.35-.45c.09-.13.17-.27.26-.41zm-.46.53l-.52.62c-.09-.17-.17-.35-.25-.52a5.3 5.3 0 0 0 .42-.52zm-.52 1c.09.17.18.35.28.52l-.14.16-.32.43q-.13-.33-.24-.66zm.19 0a.61.61 0 0 1-.07-.14l.56-.63.36.45c-.22.22-.44.45-.65.69-.07-.19-.14-.31-.2-.44zm1-.18c.15.19.3.38.44.58l-.27.33-.42.52-.42-.71c.18-.32.4-.56.63-.79zm.1-.11l.31-.31.2-.2.45.46c-.18.2-.35.41-.52.62zm1.77-.63l.42-.47.24.51-.34.47c-.14-.24-.25-.41-.36-.58zm.16.72l-.12.15a5.84 5.84 0 0 0-.39-.48l.2-.22c.07.11.17.29.27.44zm-.29-.94l-.3-.45.51-.49c.08.15.15.3.22.45zm-.15.17l-.22.26c-.12-.15-.25-.29-.37-.43l.32-.3c.04.07.14.24.23.4zm-.31.37l-.12.13-.07-.07-.3-.43.09-.09c.09.09.23.24.36.39zm-.07.43c.13.15.26.31.38.47l-.13.15-.44.52-.07-.12-.3-.42zm.27.06c0-.06-.11-.12-.16-.19l.11-.12c.14.15.27.32.4.48l-.11.13zm.44.3c.11.14.2.28.3.42s0 .14-.08.2c-.1-.16-.21-.33-.33-.49zm.09-.12a.64.64 0 0 0 .1-.13l.21.39v.12zm.26-.33l.34-.45v.06c-.07.23-.15.46-.22.68zm.15-1.27l.26-.29.16.46-.19.3zm-.12-.24c-.07-.15-.15-.29-.22-.43l.35-.36c0 .15.11.31.16.47zm-.3-2.06c.08.21.15.43.23.64l.15.45-.38.39-.34-.63c0-.08-.08-.16-.13-.24zm-.52.84c.14.25.27.51.4.76l-.53.51c-.13-.18-.25-.36-.38-.53l-.09-.14.55-.69a.41.41 0 0 0 .01.02zm-.63-1.06c.16.26.32.52.47.78l-.47.58c-.03-.53-.03-.98-.04-1.43zm0 1.88l.38.58-.19.18-.15.14-.45-.56.35-.42zm-.66-1.22c.17-.31.34-.64.5-1v1.67c-.16-.23-.33-.46-.5-.68zm-.1.19c.19.25.38.5.56.76-.12.14-.23.28-.35.41-.17-.22-.32-.45-.47-.69.03-.23.12-.39.2-.59zm-.78-1l.28.34.4.54c-.08.16-.16.32-.25.47a7.6 7.6 0 0 1-.49-1zm-.37-.47a2.11 2.11 0 0 0 .19.23 1.55 1.55 0 0 1 0 .21zm.24 1.12c.1.21.2.43.31.64l.14.25-.15.26c-.16-.16-.33-.33-.49-.51.01-.3.08-.51.13-.73zm-.25.8l.46.5-.45-.5zm-.7-.88a8.45 8.45 0 0 0 .53.69 7.3 7.3 0 0 1-.59-.78zm.61 1.1c.14.17.29.32.43.48l-.25.39-.38-.48a3.55 3.55 0 0 0 .14-.48zm-.28.54l.36.46c-.12.17-.24.33-.38.5-.08-.2-.17-.39-.24-.59.03-.21.12-.33.2-.46zm-.81-1.07c.22.3.44.6.68.9l-.2.39q-.31-.74-.54-1.38zm.33 2.75c0 .24.11.48.18.71-.1.12-.19.24-.28.37-.05-.45.01-.81.04-1.17zm-.23 1.79a1.86 1.86 0 0 0 .1.39c-.25-.18-.19-.27-.16-.48zm.33.46a1.92 1.92 0 0 1-.17-.61 2.22 2.22 0 0 1 0-.37l.34-.36c.08.23.17.45.26.67l-.3.48c-.14.01-.16.08-.19.1zm.12.15c.07-.11.12-.24.18-.34l.18-.29c.08.17.16.33.25.5a1.78 1.78 0 0 1 .12.24c-.23.07-.39.12-.79-.2zm.66-.38c-.07-.13-.13-.27-.19-.4.12-.17.24-.33.37-.49a.64.64 0 0 1 .1-.13l.4.74-.32.42c-.06.06-.11.14-.17.21zm.77.72c-.35 0-.37 0-.48-.2l.08-.1.41-.52c.14.23.28.45.43.66-.15.08-.14.08-.53.07zm.53-.32c-.1-.17-.19-.35-.26-.47l-.12-.2.71-.85.1.14.28.39a6.36 6.36 0 0 0-.5.66zm1.32 0a.79.79 0 0 1-1 .35.9.9 0 0 1-.21-.19 7.33 7.33 0 0 1 .5-.78l.19-.24c.1.16.21.32.31.49a3.63 3.63 0 0 1 .2.35zm.09-.17a6.42 6.42 0 0 1-.51-.8l.56-.69a6.33 6.33 0 0 1 .36.54q-.15.39-.33.78a.89.89 0 0 0-.11.11zm.79-.18c0 .14 0 .27-.08.4-.29.13-.48.12-.6 0a6.52 6.52 0 0 0 .4-1l.3.51s-.07.02-.08.02zm0-.36l-.25-.44a1.22 1.22 0 0 1 .07-.17c.07.12.14.25.2.38zm.05-.51l-.16-.29v-.1a2 2 0 0 0 .13.25c.03-.01.02.03.02.08zm0-.68l.08-.21v.31a.47.47 0 0 0-.11-.16zm.29 1.77l-.2-.36v-.2a3.68 3.68 0 0 1 .15.47s.02.01.02.03zm0-.32c-.06-.18-.12-.34-.19-.5s0-.1 0-.15l.19.36c.03.04.02.13.02.23zm0-1.75v1.1c-.05-.14-.1-.27-.16-.4 0-.32 0-.64.09-.95a1.19 1.19 0 0 0 .08.16.28.28 0 0 0 .02.03zm0-.39a1 1 0 0 0-.07-.15c0-.15.07-.3.11-.44a.36.36 0 0 1 0 .09c.08.11.05.28.03.44zm0-1.17c0-.1-.07-.21-.11-.32l.24-.26c.03.14-.01.33-.06.52zm.13.41v-.16a1.24 1.24 0 0 1 .07.09zm.09-1.43l-.38.36c0-.16-.11-.31-.16-.47.2-.21.4-.43.58-.66v.54zm.28.09a.43.43 0 0 1 0 .07l-.06.12a.66.66 0 0 0 0-.14l.11-.12zm-.07-.3c.06-.31.1-.62.14-.92a8 8 0 0 0 .45-.68c-.1.46-.22.92-.36 1.37-.01.01-.08.09-.16.17z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M552.66 313.67c-.07.26-.15.52-.24.77h.18a9.21 9.21 0 0 0 .33-1.09c.14-.61.25-1.23.45-1.83a5.1 5.1 0 0 1 .19-.5c.08-.18.15-.53.26-.12a4.35 4.35 0 0 1 0 .89 21 21 0 0 0 .07 2.51h.17c-.11-1.08 0-2.19-.1-3.28v-.28l-.49-.05a4.15 4.15 0 0 0-.35 1c-.13.62-.29 1.31-.47 1.98zM554.64 314.15l.25-.07a.75.75 0 0 0 .11-.08 13.12 13.12 0 0 0 .69-1.41 6.71 6.71 0 0 1 .53-1.23 9.52 9.52 0 0 1-.32 2.42l.18-.08a9.53 9.53 0 0 0 .28-2.27l-.28-.14a15.23 15.23 0 0 0-1 2.21c-.18.19-.31.42-.44.65zM556.32 311.26a.16.16 0 0 0 .13-.17.19.19 0 0 0-.19-.18.18.18 0 0 0-.18.19.14.14 0 0 0 0 .06l-.06.09.28.14zM551.3 310.51a.13.13 0 0 0 0-.06.22.22 0 0 0-.22-.2.21.21 0 0 0-.2.21.16.16 0 0 0 0 .09.35.35 0 0 0-.11.13l.63-.06a.36.36 0 0 0-.1-.11zM554.17 310.53a.25.25 0 0 0 0-.17.21.21 0 0 0-.25-.11.2.2 0 0 0-.14.14.25.25 0 0 0 0 .12.4.4 0 0 0-.1.12l.53.06a.38.38 0 0 0-.04-.16zM548.5 311.14v.17l.1-.05v-.08a.14.14 0 0 1 .15 0l.12-.05-.16-.15a.17.17 0 0 0-.17-.19l-.13.06a.18.18 0 0 0 .09.29zM547.64 311.81v-.06a.12.12 0 0 0 0-.1.18.18 0 0 0-.17-.17.17.17 0 0 0-.17.18.16.16 0 0 0 .16.16.76.76 0 0 1 0 .15z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M548.63 311.18v.08l.2-.07a.14.14 0 0 0-.2-.01z"
        style={{
          fill: "url(#s-98a276cdc1-b)",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M552.11 310.17a10.78 10.78 0 0 0-3.54.63.17.17 0 0 1 .17.19l.16.15a9.4 9.4 0 0 1 2-.44.45.45 0 0 1 .1-.13v-.08a.2.2 0 0 1 .39 0 .13.13 0 0 1 0 .06.41.41 0 0 1 .13.1h.69a12.19 12.19 0 0 1 1.38 0l.09-.11a.41.41 0 0 1 0-.11.19.19 0 0 1 .13-.13.19.19 0 0 1 .23.25.88.88 0 0 1 0 .15 7.46 7.46 0 0 1 2 .55l.06-.09a.14.14 0 0 1 0-.06.18.18 0 0 1 .18-.19.19.19 0 0 1 .19.18.16.16 0 0 1-.13.17v.13c.55.3.86.66.87 1s-.41.88-1.15 1.25l-.18.08a6.43 6.43 0 0 1-1 .34l-.25.07-.52.11h-.17a11 11 0 0 1-1.35.14h-.68a10.78 10.78 0 0 1-1.16-.05h-.19c-.24 0-.48-.06-.7-.1h-.19a7.37 7.37 0 0 1-1.11-.31l-.12-.05-.28-.13-.19-.1a1.84 1.84 0 0 1-.31-.2l-.2-.17a.91.91 0 0 1-.33-.64 1 1 0 0 1 .32-.67.76.76 0 0 0 0-.15.16.16 0 0 1-.16-.16.17.17 0 0 1 .17-.18.18.18 0 0 1 .17.17.12.12 0 0 1 0 .1v.06a3.65 3.65 0 0 1 .84-.5v-.17a.18.18 0 0 1-.06-.28c-1.09.45-1.76 1.09-1.75 1.79a1.38 1.38 0 0 0 .47.94l.18.15.21.15a1.07 1.07 0 0 0 .21.13 3.2 3.2 0 0 0 .37.19l.23.1.17.06.13.05a8.05 8.05 0 0 0 1 .25h.37l.53.07h.21l.69.05H552.91c.39 0 .76-.08 1.11-.14H554.32l.26-.05.2-.05.18-.05.43-.13.17-.06.14-.05.21-.08.11-.05.32-.15a5 5 0 0 0 .48-.3 2.43 2.43 0 0 0 .25-.2 1.43 1.43 0 0 0 .56-1.09c-.03-1.3-2.46-2.28-5.52-2.21z"
        style={{
          fill: "url(#s-98a276cdc1-ab)",
        }}
        transform="translate(-114.32 -239.04)"
      />
    </g>
    <g id="basketball" className="basketballTwo">
      <path
        d="M132.07 103.53h-2.04l1.41-1.4h1.74l-1.11 1.4z"
        style={{
          fill: "#4d4d4d",
        }}
      />
      <path
        d="M132.07 149.25l1.11-.68v-46.44l-1.11 1.4v45.72z"
        style={{
          fill: "#666",
        }}
      />
      <path
        d="M132.07 149.25l-2.04-.13v-45.59h2.04v45.72z"
        style={{
          fill: "#333",
        }}
      />
      <path
        d="M132.07 111.34l1.11-.61 7.44-12.24h-.86l-7.69 12.85z"
        style={{
          fill: "#4d4d4d",
        }}
      />
      <path
        d="M132.07 108.69v2.65l7.68-12.85h.87v-2.02l-1.27.17-7.28 12.05z"
        style={{
          fill: "#333",
        }}
      />
      <path
        d="M253.74 321.57c-3.34.61-6.41 5.65-7.27 10.91l.39 5.86 2.45 5.84 11.37-6.54 1.06-6.58v-4.61c-1.64-3.31-4.27-5.57-8-4.88z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M249.26 344.32l-2.49-6-.39-5.86c.91-5.59 4.14-10.42 7.35-11 4.27-.78 6.76 2.25 8.1 4.93v4.66l-1.08 6.64zm-2.31-6l2.4 5.73 11.24-6.46 1.06-6.54v-4.57c-1.31-2.62-3.74-5.57-7.89-4.81-3.13.57-6.3 5.33-7.19 10.83z"
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M249.7 343.44l-2.36-5.66-.36-5.42c.85-5.24 3.87-9.74 6.88-10.29 4-.73 6.35 2.11 7.59 4.62V331l-1 6.2-.08.05zm-2-5.72l2.17 5.18 10.26-5.9 1-6v-4.19c-1.19-2.39-3.4-5.06-7.17-4.37-2.86.52-5.74 4.88-6.57 9.93z"
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M250.7 340.18v-7.51l8.17-4.67v7.44zm.79-7.08v5.73l6.59-3.81v-5.69z"
        style={{
          fill: "#1a1a1a",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M139.82 101l2.27-1.3v-2.04l-2.27 1.28V101z"
        style={{
          fill: "#c1272d",
        }}
      />
      <path
        d="M255.89 338.68a2.82 2.82 0 0 1 .84-.67 4.27 4.27 0 0 1 1.16-.49l-1.49-.82-2 1.12z"
        style={{
          fill: "#ea371f",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M255.89 339.12l6-1.64a.13.13 0 0 0 .11-.15.15.15 0 0 0-.16-.11l-6 1.64a.13.13 0 0 0-.11.15.13.13 0 0 0 .16.11z"
        style={{
          fill: "url(#s-98a276cdc1-c)",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M256.63 340.29a.16.16 0 0 0 .12 0 .14.14 0 0 0 0-.19l-1.19-1.1a.15.15 0 0 0-.2 0 .13.13 0 0 0 0 .19l1.18 1.05z"
        style={{
          fill: "url(#s-98a276cdc1-d)",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M256.67 340.93a3.61 3.61 0 0 1-.15-.65l-.19-.13c.1.26.21.52.34.78zM257.41 341.13c.13.25.27.51.41.75a4.79 4.79 0 0 1-.43-1.2l-.16-.05zM262.07 343.25c.19-.2.38-.4.55-.61a9.6 9.6 0 0 0-.2-1.07v-.11c-.21.3-.43.59-.65.87l.22.63zM258.32 339.66c.08.32.17.63.25.95l.63.08c0-.68.05-1.36.11-2a2.87 2.87 0 0 1 .14-1.08 8.39 8.39 0 0 0-1.74.37 3.8 3.8 0 0 1 .61 1.68zM257.91 341.83a5.39 5.39 0 0 0 .88 1.19c0-.1.07-.21.1-.31a2.62 2.62 0 0 0 .09-.38c-.13-.33-.25-.67-.36-1-.09-.12-.18-.25-.26-.38a6.74 6.74 0 0 1-.86-.22 4.36 4.36 0 0 0 .41 1.1zM262.49 341.28a6.84 6.84 0 0 1 .26 1.21l.05-.07c.07-.52.11-1.05.13-1.58h-.18zM260.31 339.89c0-.3-.07-.6-.11-.9a4.8 4.8 0 0 0-.18-1.06c0-.08-.12-.26-.21-.28s-.23.19-.27.33a4.08 4.08 0 0 0-.09.93c0 .55-.05 1.17-.08 1.8h1c0-.25-.02-.53-.06-.82zM260.57 341.12a1.94 1.94 0 0 0 0 .24l.09-.24h-.11zM263 342.18c.15-.22.29-.43.42-.66a5.69 5.69 0 0 0 .06-.83l-.38.11c-.02.46-.1.92-.1 1.38zM262.42 341.08a.86.86 0 0 0 .1-.16h-.12a.51.51 0 0 0 .02.16zM260.44 341.61v-.49h-.34c.1.16.22.32.34.49zM258.76 341.24l.34.42c0-.2 0-.4.06-.6l-.47-.06a2.17 2.17 0 0 0 .07.24zM259.27 341.87l.33.44.31.39c.13-.25.26-.49.38-.74a.83.83 0 0 0 .07-.13 7.28 7.28 0 0 1-.4-.72 6.08 6.08 0 0 1-.61 0c-.02.23-.05.5-.08.76zM260.6 341.68v.19c.18.3.36.61.52.91l.44-.54c-.13-.38-.27-.76-.38-1.14h-.34c-.07.2-.15.39-.24.58zM263.61 341l.14-.39h-.13c0 .15 0 .26-.01.39zM261.67 342.12c.22-.29.44-.58.65-.88l-.06-.26c-.32 0-.65.09-1 .11.16.34.28.68.41 1.03zM262.35 340.59l.45-.09.34-.59a12.06 12.06 0 0 1 .91-1.88 6.87 6.87 0 0 0-1.82-.46v.24c.13.92.02 1.86.12 2.78zM265.07 339c0-.3-.29-.61-.77-.87a8.23 8.23 0 0 1-.25 1.93c.66-.3 1.03-.68 1.02-1.06zM257 341.46c.19.34.4.67.62 1h.05v.11c.23.33.48.66.74 1l.1.12a3.54 3.54 0 0 0 .16-.34 8.71 8.71 0 0 1-1-1.41 7 7 0 0 1-.6-1.34l-.33-.16c.03.3.11.66.26 1.02zM256.62 339.9a1.48 1.48 0 0 0 .28.17c-.13-.39-.25-.79-.35-1.2a5.88 5.88 0 0 0 .07 1.03z"
        style={{
          fill: "none",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M260.54 340.75h.3q.12-.33.21-.66c.16-.57.25-1.15.43-1.72a3.54 3.54 0 0 1 .32-.85h-1.23a6.08 6.08 0 0 0-.61 0 3.55 3.55 0 0 1 .42 1.64c.08.53.13 1.06.16 1.59zM262.13 338.48a3.12 3.12 0 0 0 0-.75c-.1-.35-.16-.05-.23.1a3.2 3.2 0 0 0-.17.43 14.11 14.11 0 0 0-.4 1.55 9.15 9.15 0 0 1-.29.93 10.57 10.57 0 0 0 1.19-.13 18.74 18.74 0 0 1-.1-2.13zM257.31 340.26a8 8 0 0 1 0-2.18 3.36 3.36 0 0 0-.74.43c.13.55.29 1.11.47 1.65zM263.24 342.83c.16-.31.31-.62.44-.93a9.68 9.68 0 0 0 .35-1.41h-.1a4.44 4.44 0 0 1-.37 1 9 9 0 0 1-.32 1.34z"
        style={{
          fill: "none",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M144.19 101.93z"
        style={{
          fill: "none",
        }}
      />
      <path
        d="M263.93 341.57c0 .15-.09.3-.14.46a8.58 8.58 0 0 0 .95-1.92c-.13.08-.27.17-.43.25a10.22 10.22 0 0 1-.38 1.21zM264.17 338.09a5.81 5.81 0 0 0-.47 1.05 10.26 10.26 0 0 1-.61 1.19l-.06.11a5.4 5.4 0 0 0 .86-.29 7.21 7.21 0 0 0 .28-2.06zM260.11 344l.31-.35-.49-.65-.24.41c.13.15.31.35.42.59zM263 342.45l-.12.78a1.8 1.8 0 0 1 .2-.19c.12-.39.23-.77.31-1.16q-.23.29-.39.57zM262.12 343.39l.15.39.37-.37v-.12-.46c-.16.17-.34.38-.52.56zM257.36 339.24a6.34 6.34 0 0 0 .06 1.07 8.68 8.68 0 0 0 1 .27c-.15-.55-.29-1.1-.42-1.64 0-.13-.17-.83-.39-1l-.17.07a3.85 3.85 0 0 0-.05.71c-.02.2-.03.36-.03.52zM260.61 342.23v1.15l.42-.49q-.2-.33-.42-.66zM259.84 342.83l-.36-.45-.25-.3a1.55 1.55 0 0 1-.06.31 6.65 6.65 0 0 0 .44.84zM256.44 338.64a.85.85 0 0 0-.29.58.77.77 0 0 0 .3.54 7 7 0 0 1-.01-1.12zM260.45 342c-.14.27-.28.54-.44.81l.45.58q0-.7-.01-1.39zM261.63 343.67c.12-.1.23-.21.34-.32l-.13-.39c-.07-.18-.13-.36-.2-.55l-.42.52.11.2c.1.18.21.36.3.54zM259.07 341.89c-.06-.07-.11-.14-.17-.2.05.12.09.24.14.37zM259.52 343.39l-.13-.21a5.6 5.6 0 0 1-.27-.55c-.05.19-.11.38-.17.55l.43.44zM258.74 343.15c-.16-.19-.32-.38-.47-.58.15.21.3.41.46.61z"
        style={{
          fill: "none",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M257.31 340.26l.11.05a6.34 6.34 0 0 1-.06-1.07v-.48a3.85 3.85 0 0 1 .05-.71h-.09a8 8 0 0 0-.01 2.21zM259.2 340.69h.17c0-.63 0-1.25.08-1.8a4.08 4.08 0 0 1 .09-.93c0-.14.1-.37.27-.33s.18.2.21.28a4.8 4.8 0 0 1 .18 1.06c0 .3.08.6.11.9s.06.57.08.86h.15c0-.53-.08-1.06-.16-1.59a3.55 3.55 0 0 0-.42-1.64l-.51.05a2.87 2.87 0 0 0-.14 1.08c-.06.7-.07 1.37-.11 2.06zM256.62 339.9a5.88 5.88 0 0 1-.07-1c.1.41.22.81.35 1.2l.17.09c-.18-.54-.34-1.1-.47-1.65l-.16.13a7 7 0 0 0 0 1.12zM257.42 337.65a.17.17 0 0 0-.12.05l.13-.05zM258 338.94c.13.54.27 1.09.42 1.64h.16c-.08-.32-.17-.63-.25-.95a3.8 3.8 0 0 0-.61-1.72h-.11c.21.2.39.9.39 1.03z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M263.79 342c0-.16.1-.31.14-.46a10.22 10.22 0 0 0 .37-1.19l-.28.13a9.68 9.68 0 0 1-.35 1.41c-.13.31-.28.62-.44.93a9 9 0 0 0 .32-1.34 4.44 4.44 0 0 0 .37-1l-.18.07-.14.39v-.34h-.15a5.69 5.69 0 0 1-.06.83c-.13.23-.27.44-.42.66.05-.46.09-.92.1-1.38h-.16c0 .53-.06 1.06-.13 1.58l-.05.07a6.84 6.84 0 0 0-.26-1.21l.26-.4-.23.05a.86.86 0 0 1-.1.16.51.51 0 0 1 0-.13h-.14l.06.26c-.21.3-.43.59-.65.88-.13-.35-.25-.69-.4-1h-.08c.11.38.25.76.38 1.14l-.44.54c-.16-.3-.34-.61-.52-.91v-.19c0-.06.17-.38.25-.57h-.17l-.09.24a1.94 1.94 0 0 1 0-.24h-.16v.49c-.12-.17-.24-.33-.37-.49H260a7.28 7.28 0 0 0 .4.72.83.83 0 0 1-.07.13c-.12.25-.25.49-.38.74l-.31-.39-.33-.44c0-.26.06-.53.08-.79h-.19c0 .2 0 .4-.06.6l-.34-.42a2.17 2.17 0 0 1-.07-.24H258.4c.08.13.17.26.26.38.11.34.23.68.36 1a2.62 2.62 0 0 1-.09.38c0 .1-.06.21-.1.31a5.39 5.39 0 0 1-.88-1.19 4.36 4.36 0 0 1-.41-1.11h-.11a4.79 4.79 0 0 0 .43 1.2c-.14-.24-.28-.5-.41-.75l-.18-.5-.2-.08a7 7 0 0 0 .6 1.34 8.71 8.71 0 0 0 1 1.41 3.54 3.54 0 0 1-.16.34l-.1-.12c-.26-.32-.51-.65-.74-1v-.11h-.05c-.22-.33-.43-.66-.62-1s-.19-.72-.26-1.07l-.18-.11a3.61 3.61 0 0 0 .15.65 8.78 8.78 0 0 1-.34-.78l-.16-.13a10 10 0 0 0 1.49 2.78c.11.37.23.74.37 1.1a4 4 0 0 0 0 .6 11.71 11.71 0 0 1-.09 1.57v.36c-.09.41-.31 1.6.28 1.19a.71.71 0 0 0 .33.24.52.52 0 0 0 .52-.16c.14.23.33.46.58.44a.51.51 0 0 0 .37-.25l.09-.13a.67.67 0 0 0 .92.16 1.18 1.18 0 0 0 .29-.3.77.77 0 0 0 .18.18c.35.24.52-.14.58-.42v-.09l.18.32a.08.08 0 0 0 .14 0 6.42 6.42 0 0 0 .09-1.75 4.78 4.78 0 0 1 .08-.84v-.06c.06-.28.13-.56.21-.83l.07-.12a10 10 0 0 0 .56-1.14v-.05a1.17 1.17 0 0 0 .05-.11 10.57 10.57 0 0 0 1.4-2.71l-.22.17a8.58 8.58 0 0 1-.89 1.9zm-1.41-.6v.11a9.6 9.6 0 0 1 .2 1.07c-.17.21-.36.41-.55.61l-.12-.32-.22-.63c.31-.24.48-.51.69-.81zm-4.15 3c.07.16.14.33.22.49l-.21.22q-.06-.32-.09-.63zm-.09 0v-.28c0 .06.05.13.08.19zm.38.64c.07.15.14.3.22.44l-.33.39c-.05-.2-.1-.41-.14-.61zm1.66-.42l-.21-.18zm-.11-.31l.07-.08.41.45-.08.07c-.13-.16-.26-.31-.4-.45zm.22.6l-.43.4-.33-.39.35-.38c.12.11.28.23.41.36zm-.37-.75l-.43-.43a1.28 1.28 0 0 0 .11-.2 5.47 5.47 0 0 0 .41.54zm-.1.11l-.08-.07c-.12-.11-.23-.21-.33-.32zm-.11.12l-.32.36-.31-.37.23-.35zm-.41.46l-.46.52c-.08-.14-.15-.29-.22-.44.13-.14.26-.29.38-.44zm-.46.82c.08.15.16.3.25.44l-.13.14-.28.36c-.08-.18-.15-.37-.21-.55zm.17 0a.75.75 0 0 0-.07-.12c.17-.17.34-.36.5-.54l.32.39a7.94 7.94 0 0 0-.57.59zm.85-.16l.39.5-.24.28-.37.44c-.12-.2-.25-.4-.37-.61.19-.21.39-.41.59-.61zm.09-.09a3.45 3.45 0 0 1 .28-.26c0-.06.11-.11.17-.17l.4.39-.46.53zm1.57-.53l.37-.4c.07.14.14.29.22.43-.1.14-.2.27-.31.4-.09-.14-.18-.32-.28-.43zm.14.61l-.1.12-.35-.4.18-.19zm-.26-.8c-.09-.12-.17-.25-.26-.38l.45-.42.2.39zm-.13.14c-.06.08-.13.15-.2.23l-.33-.37.28-.26zm-.28.32l-.1.11-.06-.06q-.13-.19-.27-.36l.08-.08zm-.05.36c.12.13.23.26.34.4l-.11.13-.39.44-.07-.1-.26-.35c.16-.16.33-.34.49-.52zm.23.06a1.07 1.07 0 0 0-.14-.16l.1-.11c.12.13.24.27.35.41l-.1.11a2.32 2.32 0 0 0-.21-.25zm.4.25l.26.36c0 .06-.05.11-.07.17l-.29-.42zm.08-.1l.09-.11.18.33v.1a2.55 2.55 0 0 1-.27-.32zm.23-.28l.3-.38v.05l-.19.58zm.13-1.08l.23-.25c.05.14.09.27.14.4-.05.09-.11.17-.17.26-.07-.14-.13-.28-.21-.41zm-.11-.2c-.06-.13-.13-.25-.2-.37l.32-.31.14.41a3.38 3.38 0 0 0-.26.27zm-.26-1.76c.07.19.13.37.2.55l.13.39c-.11.11-.22.22-.34.32-.09-.18-.2-.36-.3-.54l-.11-.2zm-.47.72c.13.21.24.43.36.65l-.48.43-.33-.45-.08-.12.49-.59zm-.56-.9q.22.33.42.66l-.42.49c.01-.38.01-.77 0-1.15zm0 1.6c.11.16.23.32.34.49l-.18.15-.12.12a8.47 8.47 0 0 1-.4-.48l.3-.35zm-.59-1c.16-.27.3-.54.44-.81v1.41l-.45-.58zm-.08.16l.49.65-.31.35c-.15-.19-.29-.39-.42-.59zm-.7-.87l.25.3.36.45-.23.4a6.65 6.65 0 0 1-.44-.84 1.55 1.55 0 0 0 .05-.35zm-.33-.39c.06.06.11.13.17.2v.17c-.08-.17-.08-.29-.18-.41zm.22.94a5.6 5.6 0 0 0 .27.55l.13.21-.14.23-.43-.44c.04-.22.11-.4.16-.59zm-.22.69c.13.14.27.28.4.43-.14-.14-.27-.29-.4-.43zm-.63-.75c.15.2.31.39.47.58-.18-.19-.33-.41-.48-.62zm.54.94l.39.4-.23.33-.33-.4c.05-.15.11-.26.16-.37zm-.25.45l.33.39a4.78 4.78 0 0 1-.34.42c-.08-.16-.15-.32-.22-.49a2.35 2.35 0 0 0 .22-.32zm-.72-.91l.61.77-.18.33c-.16-.41-.28-.77-.44-1.14zm.3 2.34c0 .2.1.4.16.6s-.17.21-.25.31c0-.34.05-.65.08-.95zm-.21 1.52a1.39 1.39 0 0 0 .1.33c-.18-.15-.13-.19-.11-.37zm.3.39a1.41 1.41 0 0 1-.15-.51 1.73 1.73 0 0 1 0-.32l.31-.31a3.57 3.57 0 0 0 .23.57 4.81 4.81 0 0 0-.27.41c-.09.05-.1.1-.13.12zm.11.13c.05-.1.1-.21.15-.29l.17-.25a4.13 4.13 0 0 0 .22.42 2.21 2.21 0 0 0 .11.21c-.16.09-.36.14-.66-.13zm.58-.32c-.06-.12-.12-.23-.17-.35q.15-.21.33-.42l.09-.1c.12.21.23.42.36.63-.1.12-.2.23-.29.35l-.15.18zm.68.61c-.31 0-.32 0-.42-.17l.07-.09.37-.44a3.67 3.67 0 0 0 .38.56c-.09.11-.09.11-.41.1zm.47-.28c-.09-.14-.16-.29-.23-.39l-.1-.17c.2-.24.41-.49.63-.73l.09.12.24.34c-.15.18-.3.36-.44.55s-.14.15-.2.24zm1.17 0a.71.71 0 0 1-.86.3.5.5 0 0 1-.19-.17 6.75 6.75 0 0 1 .44-.65l.17-.21.28.41c.06.09.11.2.17.3zm.08-.15a4.56 4.56 0 0 1-.44-.67l.49-.59c.11.15.22.3.32.46q-.13.33-.3.66a.91.91 0 0 1-.08.13zm.71-.14c0 .11 0 .22-.08.33-.25.11-.42.11-.52 0a5.77 5.77 0 0 0 .35-.82c.09.14.18.29.26.44s-.05.01-.05.04zm0-.31c-.07-.13-.14-.25-.22-.37l.06-.15.18.32zm0-.44c0-.08-.09-.16-.14-.24a.2.2 0 0 1 0-.08 2.12 2.12 0 0 0 .11.21.41.41 0 0 1 .1.1zm0-.57l.06-.18v.26a.56.56 0 0 0 0-.09zm.25 1.5l-.17-.31a.88.88 0 0 0 0-.16 2.24 2.24 0 0 1 .14.39.09.09 0 0 1 .09.07zm0-.27a3.16 3.16 0 0 0-.16-.43v-.13l.17.32a1.94 1.94 0 0 1 .09.23zm0-1.49v.93c0-.11-.09-.22-.14-.34a7 7 0 0 1 .07-.8.61.61 0 0 1 .07.14zm0-.33l-.06-.12c0-.12.06-.25.1-.37v.08c.15.13.13.26.11.4zm0-1c0-.09-.07-.18-.1-.27l.21-.22c.12.21.09.33.05.49zm.11.34v-.13zm.08-1.21l-.37.37-.15-.39c.18-.18.36-.37.52-.56v.46c0 .16.17.08.16.12zm.25.08v.06l-.05.1v-.12l.11-.1zm-.06-.26l.12-.78q.21-.29.39-.57c-.08.39-.19.77-.31 1.16a1.8 1.8 0 0 0-.04.19z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M261.05 340.09q-.09.33-.21.66h.16a9.15 9.15 0 0 0 .29-.93 14.11 14.11 0 0 1 .4-1.55 3.2 3.2 0 0 1 .17-.43c.07-.15.13-.45.23-.1a3.12 3.12 0 0 1 0 .75 18.74 18.74 0 0 0 .06 2.13h.16c-.1-.92 0-1.86-.09-2.78v-.24l-.43-.05a3.54 3.54 0 0 0-.32.85c-.17.54-.26 1.12-.42 1.69zM262.8 340.5l.23-.06.06-.11a10.26 10.26 0 0 0 .61-1.19 5.81 5.81 0 0 1 .47-1.05 7.21 7.21 0 0 1-.28 2.06l.16-.07a8.23 8.23 0 0 0 .25-1.93l-.25-.12a12.06 12.06 0 0 0-.91 1.88z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M264.3 338.05c.06 0 .12-.09.11-.15a.16.16 0 0 0-.32 0 .13.13 0 0 0 0 .06l-.05.07.25.12zM259.85 337.43v-.05a.16.16 0 0 0-.17-.15.16.16 0 0 0-.17.16.14.14 0 0 0 0 .07.31.31 0 0 0-.08.11l.51-.05a.44.44 0 0 0-.09-.09zM262.18 337.44a.15.15 0 0 0 0-.13.16.16 0 0 0-.2-.08c-.05 0-.11 0-.11.11a.27.27 0 0 0 0 .09l-.07.09.43.05a.29.29 0 0 0-.05-.13zM257.36 337.94v.14h.09a.14.14 0 0 1 0-.07.12.12 0 0 1 .13 0h.11a.55.55 0 0 0-.14-.12.15.15 0 0 0-.14-.17l-.13.05a.16.16 0 0 0 .08.17zM256.6 338.51v-.05a.14.14 0 0 0-.13-.23.15.15 0 0 0-.15.15.14.14 0 0 0 .14.14v.12z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M257.47 338a.14.14 0 0 0 0 .07l.17-.07a.12.12 0 0 0-.17 0z"
        style={{
          fill: "url(#s-98a276cdc1-ac)",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M260.56 337.12a9.62 9.62 0 0 0-3.13.53.15.15 0 0 1 .14.17.55.55 0 0 1 .14.12 8.39 8.39 0 0 1 1.74-.37.31.31 0 0 1 .08-.11.14.14 0 0 1 0-.07.16.16 0 0 1 .17-.16.16.16 0 0 1 .17.15v.05a.44.44 0 0 1 .11.09 6.08 6.08 0 0 1 .61 0h1.23l.07-.09a.27.27 0 0 1 0-.09c0-.06.06-.1.11-.11a.16.16 0 0 1 .2.08.15.15 0 0 1 0 .13.29.29 0 0 1 .05.13 6.87 6.87 0 0 1 1.82.46l.05-.07a.13.13 0 0 1 0-.06.16.16 0 0 1 .32 0c0 .06-.05.12-.11.15v.1c.48.26.76.57.77.87s-.36.74-1 1.06l-.16.07a5.4 5.4 0 0 1-.86.29l-.23.06-.45.09h-.16a10.57 10.57 0 0 1-1.19.13H259.27l-.63-.08h-.16a8.68 8.68 0 0 1-1-.27l-.11-.05-.24-.1-.17-.09a1.48 1.48 0 0 1-.28-.17l-.17-.14a.77.77 0 0 1-.3-.54.85.85 0 0 1 .29-.58v-.12a.14.14 0 0 1-.14-.14.15.15 0 0 1 .15-.15.14.14 0 0 1 .13.23v.05a3.36 3.36 0 0 1 .74-.43V338a.16.16 0 0 1-.06-.24c-1 .39-1.56.93-1.54 1.53a1.1 1.1 0 0 0 .41.79l.16.13.19.13.18.11.33.16.2.08.16.05h.11a6.74 6.74 0 0 0 .86.22H258.71l.47.06h.19a6.08 6.08 0 0 0 .61 0h1.31c.34 0 .67-.06 1-.11h.26l.23-.05H263.12l.38-.11h.28l.18-.07h.1l.28-.13c.16-.08.3-.17.43-.25l.22-.17a1.2 1.2 0 0 0 .5-.93c-.06-1.31-2.21-2.14-4.93-2.08z"
        style={{
          fill: "url(#s-98a276cdc1-ad)",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M732.36 136.32l2.48.01-1.1-1.43-2.66-.05 1.28 1.47z"
        style={{
          fill: "#4d4d4d",
        }}
      />
      <path
        d="M732.36 188.9l-1.28-3.93v-50.12l1.28 1.47v52.58z"
        style={{
          fill: "#666",
        }}
      />
      <path
        d="M732.36 188.9l2.48.12v-52.69l-2.48-.01v52.58z"
        style={{
          fill: "#333",
        }}
      />
      <path
        d="M732.36 145.09l-1.28-.71-8.6-14.14h1l8.88 14.85z"
        style={{
          fill: "#4d4d4d",
        }}
      />
      <path
        d="M732.36 141.44v3.65l-8.87-14.85h-1.01v-2.33l1.68-.13 8.2 13.66z"
        style={{
          fill: "#333",
        }}
      />
      <g
        style={{
          isolation: "isolate",
        }}
      >
        <path d="M720.67 121.83h.62v5.28h-.62z" />
        <path
          d="M720.71 122.18h.62v4.92h-.62z"
          style={{
            fill: "#b2b2b2",
          }}
        />
        <path d="M720.8 122.23h.62v4.84h-.62zM720.67 127.11h.62l.25 7.56h-.63l-.24-7.56z" />
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-ae)",
            }}
          >
            <path
              d="M835.41 357.74h.59c-.17 1-.32 2.07-.42 3.13H835c.11-1.06.25-2.17.43-3.13"
              style={{
                isolation: "isolate",
              }}
              transform="translate(-114.32 -239.04)"
            />
          </g>
        </g>
        <path
          d="M720.71 127.1h.62l.24 7.18h-.62l-.24-7.18z"
          style={{
            fill: "#b4b4b4",
          }}
        />
        <path
          d="M720.95 134.28h.62l.02.05h-.62l-.02-.05z"
          style={{
            fill: "#bfbfbf",
          }}
        />
        <path d="M720.8 127.07h.62l.23 6.94h-.62l-.23-6.94z" />
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-af)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M835.69 356.52h.62c-.1.36-.19.77-.28 1.22h-.62c.09-.45.18-.86.28-1.22M835.41 357.74h.59c-.17 1-.32 2.07-.42 3.13H835c.11-1.06.25-2.17.43-3.13"
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-ag)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M835.44 358.12h.62c-.17.91-.3 2-.41 3H835c.1-1 .24-2.09.41-3"
                style={{
                  fill: "#a3a3a3",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-ah)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M835.71 356.94h.62c-.1.35-.19.74-.27 1.18h-.62c.08-.44.17-.83.27-1.18"
                style={{
                  fill: "#9e9e9e",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M835.44 358.12h.62c-.17.91-.3 2-.41 3H835c.1-1 .24-2.09.41-3"
                style={{
                  fill: "#a3a3a3",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <path
          d="M721.32 123.59h.62v8.6h-.62z"
          style={{
            fill: "#b2b2b2",
          }}
        />
        <path
          d="M721.51 125.13h.62v6.57h-.62z"
          style={{
            fill: "#121212",
          }}
        />
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-ai)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M835.87 356h.63a4.37 4.37 0 0 0-.19.55h-.62c.06-.21.12-.39.18-.55"
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M835.69 356.52h.62c-.1.36-.19.77-.28 1.22h-.62c.09-.45.18-.86.28-1.22"
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-aj)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M836.2 355.83h.63a.4.4 0 0 0-.1.12h-.62a.62.62 0 0 1 .09-.12"
                style={{
                  fill: "#8a8a8a",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.11 356h.62a1.45 1.45 0 0 0-.1.18H836a.77.77 0 0 1 .1-.18"
                style={{
                  fill: "#8f8f8f",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836 356.13h.62c0 .08-.08.18-.12.28h-.63a1.82 1.82 0 0 1 .13-.28"
                style={{
                  fill: "#949494",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M835.88 356.41h.63a5.46 5.46 0 0 0-.18.53h-.62a5.52 5.52 0 0 1 .17-.53"
                style={{
                  fill: "#999",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M835.71 356.94h.62c-.1.35-.19.74-.27 1.18h-.62c.08-.44.17-.83.27-1.18"
                style={{
                  fill: "#9e9e9e",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-ak)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M836.21 355.35h.62a1.47 1.47 0 0 0-.1.13h-.62a.64.64 0 0 1 .1-.13M836.11 355.48h.62c0 .06-.07.12-.1.19H836l.11-.19M836 355.67h.63a2.08 2.08 0 0 0-.13.3h-.63c0-.11.09-.21.13-.3M835.87 356h.63a4.37 4.37 0 0 0-.19.55h-.62c.06-.21.12-.39.18-.55"
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-al)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M836.54 355.17h.62a.43.43 0 0 0-.33.18h-.62a.43.43 0 0 1 .33-.18M836.21 355.35h.62a1.47 1.47 0 0 0-.1.13h-.62a.64.64 0 0 1 .1-.13"
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-am)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M836.52 355.65h.62a.41.41 0 0 0-.31.18h-.63a.43.43 0 0 1 .32-.18"
                style={{
                  fill: "#858585",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.2 355.83h.63a.4.4 0 0 0-.1.12h-.62a.62.62 0 0 1 .09-.12"
                style={{
                  fill: "#8a8a8a",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-an)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M836.52 356.09h.63a.39.39 0 0 0-.3.17h-.62a.39.39 0 0 1 .29-.17M836.23 356.26h.62l-.09.11h-.62l.09-.11M836.14 356.37h.62l-.09.17H836l.1-.17M836 356.54h.63l-.12.27h-.63l.12-.27M835.92 356.81h.63a4.86 4.86 0 0 0-.17.5h-.62c0-.18.11-.35.16-.5M835.76 357.31h.62c-.09.33-.17.7-.25 1.11h-.63c.08-.41.17-.78.26-1.11M835.5 358.42h.63c-.16.87-.29 1.88-.39 2.85h-.63c.1-1 .23-2 .39-2.85"
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-ao)",
            }}
          >
            <path
              d="M836.54 355.17h.62a.43.43 0 0 0-.33.18h-.62a.43.43 0 0 1 .33-.18"
              style={{
                isolation: "isolate",
              }}
              transform="translate(-114.32 -239.04)"
            />
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-ap)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M722.21 117.05h.63-.63"
                style={{
                  fill: "#8f8f8f",
                }}
              />
              <path
                d="M836.53 356.09"
                style={{
                  fill: "#949494",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.56 356.09"
                style={{
                  fill: "#999",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.59 356.1"
                style={{
                  fill: "#9e9e9e",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.62 356.11"
                style={{
                  fill: "#a3a3a3",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.65 356.12h.63-.63"
                style={{
                  fill: "#a8a8a8",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.69 356.14h.63H836.64"
                style={{
                  fill: "#adadad",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.75 356.18h.62-.62"
                style={{
                  fill: "#b3b3b3",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-aq)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path d="M722.2 116.61h.64-.64" />
              <path
                d="M836.66 355.68h.67-.63M836.7 355.7h.63H836.65M836.76 355.74H837.44h-.63"
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-ar)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M722.22 116.13h.63-.63"
                style={{
                  fill: "#8f8f8f",
                }}
              />
              <path
                d="M836.54 355.17"
                style={{
                  fill: "#949494",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.58 355.17"
                style={{
                  fill: "#999",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.61 355.18"
                style={{
                  fill: "#9e9e9e",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.64 355.19"
                style={{
                  fill: "#a3a3a3",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.68 355.2h.63-.67"
                style={{
                  fill: "#a8a8a8",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.73 355.22H837.41 836.73"
                style={{
                  fill: "#adadad",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.79 355.26h.62l.05.05h-.62l-.05-.05"
                style={{
                  fill: "#b3b3b3",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-as)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path d="M722.22 115.91h.63-.63" />
              <path
                d="M836.68 355h.68-.68M836.73 355h.69-.69M836.79 355.05h.68H836.79"
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-at)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M836.84 355.31h.62-.63"
                style={{
                  fill: "#b3b3b3",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.87 355.34h.63a3.06 3.06 0 0 1 .43 1h-.62a2.83 2.83 0 0 0-.44-1"
                style={{
                  fill: "#b8b8b8",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-au)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M836.85 355.09h.62-.63M836.88 355.13h.63a2.94 2.94 0 0 1 .45 1.06h-.63a2.94 2.94 0 0 0-.45-1.06"
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-av)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M836.87 355.34h.63a3.06 3.06 0 0 1 .43 1h-.62a2.83 2.83 0 0 0-.44-1"
                style={{
                  fill: "#b8b8b8",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-aw)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M836.87 355.34h.63a3.06 3.06 0 0 1 .43 1h-.62a2.83 2.83 0 0 0-.44-1"
                style={{
                  fill: "#b8b8b8",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-ax)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M836.88 355.13h.63a2.94 2.94 0 0 1 .45 1.06h-.63a2.94 2.94 0 0 0-.45-1.06M837.33 356.19h.67a30.38 30.38 0 0 1 .66 3.75H838a27 27 0 0 0-.66-3.75"
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <path
          d="M721.32 132.2h.62l1.92 5.47h-.62l-1.92-5.47z"
          style={{
            fill: "#bfbfbf",
          }}
        />
        <path
          d="M721.51 131.7h.63l1.54 4.41h-.63l-1.54-4.41z"
          style={{
            fill: "#131313",
          }}
        />
        <path
          d="M723.05 129.49h.62v6.62h-.62z"
          style={{
            fill: "#b2b2b2",
          }}
        />
        <path
          d="M721.51 125.13h.63l1.54 4.36h-.63l-1.54-4.36z"
          style={{
            fill: "#bfbfbf",
          }}
        />
        <path
          d="M721.32 123.59h.62l1.92 5.4h-.62l-1.92-5.4z"
          style={{
            fill: "#131313",
          }}
        />
        <path
          d="M723.24 128.99h.62v8.68h-.62z"
          style={{
            fill: "#121212",
          }}
        />
        <path d="M720.91 134.67h.63l2.64 7.46h-.63l-2.64-7.46z" />
        <path
          d="M720.97 134.33h.62l2.51 7.11h-.62l-2.51-7.11z"
          style={{
            fill: "#bfbfbf",
          }}
        />
        <path d="M721.03 134.01h.62l2.4 6.8h-.62l-2.4-6.8z" />
        <path
          d="M836.8 356.22c.67.6 1.35 5.65 1.55 11.47l-.09 6.18-.51 6-2.41-6.8-.23-6.94v-4.84c.26-2.46.7-5.18 1.41-5.18a.42.42 0 0 1 .28.11zm.75 20.49V368l-1.92-5.4v8.61l1.92 5.47"
          style={{
            fill: "#d0d0d0",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M723.94 134.84h.63l-.52 5.97h-.62l.51-5.97z"
          style={{
            fill: "#aeaeae",
          }}
        />
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-ay)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M836.8 356.22h.62-.63"
                style={{
                  fill: "#b3b3b3",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M836.83 356.25h.63a2.84 2.84 0 0 1 .4.95h-.63a2.65 2.65 0 0 0-.4-.95"
                style={{
                  fill: "#b8b8b8",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M837.23 357.2h.63a26.6 26.6 0 0 1 .59 3.35h-.63a23.38 23.38 0 0 0-.59-3.35"
                style={{
                  fill: "#b3b3b3",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M837.82 360.55h.63c.24 2 .43 4.48.52 7.14h-.62c-.09-2.66-.28-5.16-.53-7.14"
                style={{
                  fill: "#adadad",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <path
          d="M724.03 128.65h.62l-.08 6.19h-.63l.09-6.19z"
          style={{
            fill: "#b2b2b2",
          }}
        />
        <path
          d="M836.81 355.78c.71.64 1.42 5.85 1.62 11.89l-.08 6.27-.56 6.54-2.51-7.11v-.05l-.23-7.18v-5c.26-2.59.73-5.47 1.49-5.47a.44.44 0 0 1 .27.11zm1.45 18.09l.09-6.18c-.2-5.82-.88-10.87-1.55-11.47a.42.42 0 0 0-.28-.13c-.71 0-1.15 2.72-1.41 5.18v4.84l.23 6.94 2.41 6.8.51-6"
          transform="translate(-114.32 -239.04)"
        />
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-az)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M836.81 355.78h.63-.62M836.85 355.82h.62a2.83 2.83 0 0 1 .43 1h-.63a2.87 2.87 0 0 0-.42-1M837.27 356.82h.63a27.09 27.09 0 0 1 .62 3.53h-.62a26.81 26.81 0 0 0-.63-3.53M837.9 360.35h.62c.25 2 .45 4.6.54 7.32h-.63c-.09-2.72-.28-5.28-.53-7.32"
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-aA)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M837.31 356.37h.62a26.57 26.57 0 0 1 .65 3.7H838a28.16 28.16 0 0 0-.65-3.7"
                style={{
                  fill: "#b3b3b3",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M838 360.07h.62c.27 2.16.48 4.87.57 7.76h-.62c-.1-2.89-.3-5.6-.57-7.76"
                style={{
                  fill: "#adadad",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <path d="M724.03 134.9h.62l-.55 6.54h-.62l.55-6.54zM724.12 128.63h.62l-.09 6.27h-.62l.09-6.27z" />
        <path
          d="M836.84 355.31c.73.66 1.48 6.16 1.69 12.52l-.1 6.73-.56 6.61-2.64-7.46-.25-7.56v-5.28c.28-2.7.76-5.7 1.56-5.7a.45.45 0 0 1 .3.14zm1.51 18.63l.08-6.27c-.2-6-.91-11.25-1.62-11.89a.44.44 0 0 0-.29-.13c-.76 0-1.23 2.88-1.49 5.47v5l.23 7.18v.05l2.51 7.11.56-6.54"
          style={{
            fill: "#d0d0d0",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-aB)",
            }}
          >
            <path
              d="M837.33 356.19h.67a30.38 30.38 0 0 1 .66 3.75H838a27 27 0 0 0-.66-3.75"
              style={{
                isolation: "isolate",
              }}
              transform="translate(-114.32 -239.04)"
            />
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-aC)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M836.87 355.34h.63a3.06 3.06 0 0 1 .43 1h-.62a2.83 2.83 0 0 0-.44-1"
                style={{
                  fill: "#b8b8b8",
                }}
                transform="translate(-114.32 -239.04)"
              />
              <path
                d="M837.31 356.37h.62a26.57 26.57 0 0 1 .65 3.7H838a28.16 28.16 0 0 0-.65-3.7"
                style={{
                  fill: "#b3b3b3",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-aD)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M837.33 356.19h.67a30.38 30.38 0 0 1 .66 3.75H838a27 27 0 0 0-.66-3.75M838 359.94h.63c.27 2.19.48 4.94.58 7.88h-.63c-.1-2.94-.31-5.69-.58-7.88"
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-aE)",
            }}
          >
            <path
              d="M838 359.94h.63c.27 2.19.48 4.94.58 7.88h-.63c-.1-2.94-.31-5.69-.58-7.88"
              style={{
                isolation: "isolate",
              }}
              transform="translate(-114.32 -239.04)"
            />
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-aF)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M838 360.07h.62c.27 2.16.48 4.87.57 7.76h-.62c-.1-2.89-.3-5.6-.57-7.76"
                style={{
                  fill: "#adadad",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-aG)",
            }}
          >
            <path
              d="M838 359.94h.63c.27 2.19.48 4.94.58 7.88h-.63c-.1-2.94-.31-5.69-.58-7.88"
              style={{
                isolation: "isolate",
              }}
              transform="translate(-114.32 -239.04)"
            />
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-aH)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M838 360.07h.62c.27 2.16.48 4.87.57 7.76h-.62c-.1-2.89-.3-5.6-.57-7.76"
                style={{
                  fill: "#adadad",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <path
          d="M724.12 135.52h.62l-.56 6.61h-.63l.57-6.61z"
          style={{
            fill: "#aeaeae",
          }}
        />
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-aI)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M838 360.07h.62c.27 2.16.48 4.87.57 7.76h-.62c-.1-2.89-.3-5.6-.57-7.76"
                style={{
                  fill: "#adadad",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-aJ)",
            }}
          >
            <path
              d="M838 359.94h.63c.27 2.19.48 4.94.58 7.88h-.63c-.1-2.94-.31-5.69-.58-7.88"
              style={{
                isolation: "isolate",
              }}
              transform="translate(-114.32 -239.04)"
            />
          </g>
        </g>
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <g
            style={{
              clipPath: "url(#s-98a276cdc1-aK)",
            }}
          >
            <g
              style={{
                isolation: "isolate",
              }}
            >
              <path
                d="M838 360.07h.62c.27 2.16.48 4.87.57 7.76h-.62c-.1-2.89-.3-5.6-.57-7.76"
                style={{
                  fill: "#adadad",
                }}
                transform="translate(-114.32 -239.04)"
              />
            </g>
          </g>
        </g>
        <path
          d="M724.21 128.79h.63l-.1 6.73h-.62l.09-6.73z"
          style={{
            fill: "#b2b2b2",
          }}
        />
        <path
          d="M836.85 355.09c.75.69 1.5 6.26 1.72 12.73l-.09 6.77-.58 6.9-2.7-7.62-.26-7.7v-5.33c.28-2.81.77-5.89 1.59-5.89a.48.48 0 0 1 .32.14zm1.58 19.47l.1-6.73c-.21-6.36-1-11.86-1.69-12.52a.45.45 0 0 0-.3-.14c-.8 0-1.28 3-1.56 5.7v5.28l.25 7.56 2.64 7.46.56-6.61"
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M723.05 129.49v6.62l-1.54-4.41v-6.57l1.54 4.36z"
          style={{
            fill: "#d0d0d0",
          }}
        />
        <path
          d="M835.63 362.63l1.92 5.4v8.68l-1.92-5.47zm1.74 12.52v-6.62l-1.54-4.36v6.57l1.54 4.41"
          style={{
            fill: "#151515",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path d="M724.16 135.55h.62l-.58 6.9h-.62l.58-6.9zM724.26 128.78h.62l-.1 6.77h-.62l.1-6.77z" />
      </g>
      <path
        d="M722.74 137.96l-.62-1.72.1-2.84.54 1.29-.02 3.27z"
        style={{
          fill: "#c1272d",
        }}
      />
      <path
        d="M836.11 373.8a.59.59 0 0 0-.17-1c-.77-.45-1-.34-1-.34h1.58l.55 1.29z"
        style={{
          fill: "#ea371f",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M836.42 375.76l-6.63-4.07a.15.15 0 0 1-.13-.17.17.17 0 0 1 .19-.13l6.63 4.07a.17.17 0 0 1 .13.18.16.16 0 0 1-.19.12z"
        style={{
          fill: "url(#s-98a276cdc1-aL)",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M835.33 375.62a4.56 4.56 0 0 0 .18-.75 1.64 1.64 0 0 0 .22-.14c-.12.27-.25.6-.4.89zM834.48 375.85q-.22.45-.48.87a5 5 0 0 0 .5-1.38l.19-.06zM829.1 378.3c-.23-.22-.44-.46-.65-.7a8.73 8.73 0 0 1 .23-1.24v-.12c.25.34.5.67.76 1-.09.25-.17.49-.26.73zM833.42 374.16c-.09.37-.19.73-.29 1.09l-.72.11c0-.79-.06-1.58-.12-2.37a3.63 3.63 0 0 0-.16-1.25 10 10 0 0 1 2 .43 4.47 4.47 0 0 0-.71 1.99zM833.9 376.67a6.51 6.51 0 0 1-1 1.37c0-.12-.08-.24-.11-.36s-.08-.29-.11-.44c.16-.38.3-.77.42-1.16a4.27 4.27 0 0 0 .3-.44 7.94 7.94 0 0 0 1-.25 5.06 5.06 0 0 1-.5 1.28zM828.61 376a7.8 7.8 0 0 0-.3 1.39l-.06-.08c-.08-.6-.13-1.21-.15-1.82h.21zM831.12 374.42c0-.34.09-.69.14-1a5 5 0 0 1 .2-1.22c0-.09.14-.3.24-.32s.28.22.32.38a4.79 4.79 0 0 1 .1 1.07c0 .64.06 1.36.1 2.08a11.36 11.36 0 0 1-1.19.05zM830.83 375.85a2.45 2.45 0 0 0 0 .27c0-.09-.08-.18-.11-.27h.13zM828 377.07a7 7 0 0 1-.49-.76 5.07 5.07 0 0 1-.07-.95l.43.12c.06.52.13 1.06.13 1.59zM828.69 375.8l-.12-.19h.15zM831 376.42v-.57h.4a4.73 4.73 0 0 0-.4.57zM832.92 376l-.4.49c0-.23 0-.46-.07-.69l.55-.07a2.76 2.76 0 0 1-.08.27zM832.34 376.72l-.39.5-.36.45-.44-.85-.08-.15c.17-.27.33-.55.47-.83h.7c.02.27.05.57.1.88zM830.79 376.49a1.62 1.62 0 0 1 0 .22q-.31.53-.6 1.05c-.18-.2-.35-.41-.51-.62.16-.44.31-.88.44-1.32h.39c.09.24.18.46.28.67zM827.31 375.69c-.06-.14-.1-.29-.16-.44l.15.05c0 .13 0 .26.01.39zM829.56 377c-.26-.33-.51-.67-.76-1 0-.1.05-.2.08-.3a9.91 9.91 0 0 0 1.14.13c-.17.37-.32.77-.46 1.17zM828.78 375.23l-.53-.1c-.14-.23-.27-.45-.39-.68a14.46 14.46 0 0 0-1.05-2.17 7.79 7.79 0 0 1 2.1-.54v.28c-.15 1.07-.03 2.15-.13 3.21zM825.63 373.42c0-.35.33-.7.89-1a8.61 8.61 0 0 0 .29 2.22c-.76-.36-1.19-.8-1.18-1.22zM835 376.24c-.22.39-.46.78-.72 1.15h-.06v.12c-.27.39-.56.76-.86 1.13l-.11.15a3.39 3.39 0 0 1-.18-.39 10.41 10.41 0 0 0 1.17-1.64 7.37 7.37 0 0 0 .68-1.55 3.52 3.52 0 0 0 .39-.18c-.09.38-.19.79-.31 1.21zM835.39 374.44a3 3 0 0 1-.32.2c.15-.46.29-.92.4-1.4a6.79 6.79 0 0 1-.08 1.2z"
        style={{
          fill: "none",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M830.86 375.42h-.34a6.75 6.75 0 0 1-.25-.76c-.18-.65-.29-1.33-.5-2a3.73 3.73 0 0 0-.36-1 13 13 0 0 1 1.42 0h.7a4.31 4.31 0 0 0-.49 1.91q-.12.94-.18 1.85zM829 372.8a3.61 3.61 0 0 1 .06-.87c.11-.4.18-.06.26.12a4.19 4.19 0 0 1 .2.49c.2.59.31 1.2.46 1.8a10.16 10.16 0 0 0 .33 1.07q-.74 0-1.38-.15a20.1 20.1 0 0 0 .07-2.46zM834.59 374.86a8.87 8.87 0 0 0 0-2.52 4 4 0 0 1 .86.48c-.15.65-.34 1.29-.55 1.92zM827.74 377.83c-.18-.36-.35-.72-.5-1.09a11 11 0 0 1-.41-1.62h.11a5.68 5.68 0 0 0 .43 1.11 10.71 10.71 0 0 0 .37 1.6z"
        style={{
          fill: "none",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M718.89 136.63z"
        style={{
          fill: "none",
        }}
      />
      <path
        d="M826.94 376.37c0 .17.11.35.17.52a9.81 9.81 0 0 1-1.11-2.22 3.48 3.48 0 0 0 .5.3 11 11 0 0 0 .44 1.4zM826.67 372.34a6.88 6.88 0 0 1 .54 1.21 13.89 13.89 0 0 0 .7 1.39.75.75 0 0 1 .07.12 8.19 8.19 0 0 1-1-.33 8.82 8.82 0 0 1-.31-2.39zM831.36 379.11l-.36-.4.57-.75.27.48a8.12 8.12 0 0 1-.48.67zM828.08 377.38c0 .3.09.6.14.9l-.23-.22c-.14-.44-.27-.89-.37-1.34a6 6 0 0 0 .46.66zM829 378.47c0 .15-.11.3-.16.46l-.43-.43v-.15-.53zM834.54 373.67a7.31 7.31 0 0 1-.08 1.24 7.33 7.33 0 0 1-1.13.31c.17-.63.33-1.27.48-1.89 0-.16.2-1 .45-1.11l.19.07a4.54 4.54 0 0 1 .07.83c.01.18.02.37.02.55zM830.78 377.13v1.33l-.49-.56c.16-.26.32-.52.49-.77zM831.68 377.83c.13-.18.27-.35.41-.53l.28-.34c0 .12 0 .24.07.36a8.12 8.12 0 0 1-.51 1zM835.6 373a1 1 0 0 1 .34.67.93.93 0 0 1-.35.62 8 8 0 0 0 .01-1.29zM831 376.84c.16.31.33.63.51.94l-.51.67v-1.61zM829.6 378.8l-.39-.38.15-.44c.08-.21.15-.43.23-.64l.48.6c0 .08-.08.16-.13.24zM832.56 376.73l.19-.23-.15.43a1.42 1.42 0 0 1-.04-.2zM832 378.47l.15-.24c.11-.21.22-.42.32-.63a6.55 6.55 0 0 0 .19.63l-.5.5zM832.94 378.2c.19-.22.37-.45.55-.68-.17.24-.35.48-.54.71z"
        style={{
          fill: "none",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M834.59 374.86l-.13.05a7.31 7.31 0 0 0 .08-1.24v-.55a4.54 4.54 0 0 0-.07-.83h.11a8.87 8.87 0 0 1 .01 2.57zM832.41 375.36h-.19c0-.72-.05-1.44-.1-2.08a4.79 4.79 0 0 0-.1-1.07c0-.16-.11-.43-.32-.38s-.2.23-.24.32a5 5 0 0 0-.2 1.22c0 .35-.1.7-.14 1l-.09 1h-.17q.06-.92.18-1.83a4.31 4.31 0 0 1 .49-1.91l.6.06a3.63 3.63 0 0 1 .16 1.25c.06.84.07 1.63.12 2.42zM835.39 374.44a6.79 6.79 0 0 0 .08-1.2c-.11.48-.25.94-.4 1.4l-.2.1c.21-.63.4-1.27.55-1.92l.18.16a8 8 0 0 1 0 1.29zM834.47 371.84a.15.15 0 0 1 .13.06l-.14-.06zM833.81 373.33c-.15.62-.31 1.26-.48 1.89h-.2c.1-.36.2-.72.29-1.09a4.47 4.47 0 0 1 .71-2l.13.05c-.26.19-.41.99-.45 1.15z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M826 374.67l-.25-.19a12.82 12.82 0 0 0 1.62 3.14l.06.13a.06.06 0 0 0 0 .05 11.26 11.26 0 0 0 .65 1.3 1.09 1.09 0 0 0 .08.15 7.77 7.77 0 0 1 .24.95.06.06 0 0 0 0 .07 5.23 5.23 0 0 1 .1 1 7.65 7.65 0 0 0 .11 2 .09.09 0 0 0 .16 0l.23-.27v.11c.08.32.27.77.68.48a.67.67 0 0 0 .2-.21 1.26 1.26 0 0 0 .34.35.77.77 0 0 0 1.06-.18l.1.15a.61.61 0 0 0 .43.3c.3 0 .51-.25.67-.51a.6.6 0 0 0 .6.18.75.75 0 0 0 .38-.28h.05c.69.48.42-.89.32-1.37a2.93 2.93 0 0 0 0-.41 12.21 12.21 0 0 1-.1-1.81 5.3 5.3 0 0 0 0-.69c.15-.42.3-.84.42-1.27a11.38 11.38 0 0 0 1.72-3.22 1.37 1.37 0 0 1-.18.16c-.12.3-.25.6-.4.89a4.56 4.56 0 0 0 .18-.75 1.07 1.07 0 0 1-.21.13c-.08.41-.18.82-.3 1.24s-.46.78-.72 1.15h-.06v.12c-.27.39-.56.76-.86 1.13l-.11.15a3.39 3.39 0 0 1-.18-.39 10.41 10.41 0 0 0 1.17-1.64 7.37 7.37 0 0 0 .68-1.55l-.22.1-.21.57q-.22.45-.48.87a5 5 0 0 0 .5-1.38l-.13.05a5.06 5.06 0 0 1-.47 1.28 6.51 6.51 0 0 1-1 1.37c0-.12-.08-.24-.11-.36s-.08-.29-.11-.44c.16-.38.3-.77.42-1.16a4.27 4.27 0 0 0 .3-.44h-.38a2.76 2.76 0 0 1-.08.27l-.4.49c0-.23 0-.46-.07-.69h-.21c0 .31 0 .61.1.92l-.39.5-.36.45-.44-.85-.08-.15c.17-.27.33-.55.47-.83h-.13a4.73 4.73 0 0 0-.43.57v-.57h-.18a2.45 2.45 0 0 0 0 .27c0-.09-.08-.18-.11-.27h-.2c.1.22.19.44.29.65a1.62 1.62 0 0 1 0 .22q-.31.53-.6 1.05c-.18-.2-.35-.41-.51-.62.16-.44.31-.88.44-1.32h-.1c-.17.39-.32.79-.46 1.19-.26-.33-.51-.67-.76-1 0-.1.05-.2.08-.3h-.16v.15l-.12-.19-.26-.06.3.47a7.8 7.8 0 0 0-.3 1.39l-.06-.08c-.08-.6-.13-1.21-.15-1.82h-.19c0 .53.06 1.06.13 1.59a7 7 0 0 1-.49-.76 5.07 5.07 0 0 1-.07-.95l-.18-.06v.39c-.06-.14-.1-.29-.16-.44l-.21-.09a5.68 5.68 0 0 0 .43 1.11 10.71 10.71 0 0 0 .37 1.56c-.18-.36-.35-.72-.5-1.09a11 11 0 0 1-.41-1.62l-.33-.15a11 11 0 0 0 .42 1.38c0 .17.11.35.17.52a9.81 9.81 0 0 1-1.09-2.28zm3.49 2.54c-.09.25-.17.49-.26.73l-.13.36c-.23-.22-.44-.46-.65-.7a8.73 8.73 0 0 1 .23-1.24v-.12c.32.31.55.64.81.97zm4.13 2.52c0 .25-.06.49-.1.73l-.24-.26c.09-.18.17-.37.25-.56zm0-.21l.09-.22v.33zm-.09 1.1c0 .24-.1.47-.17.7l-.38-.44c.09-.17.18-.34.26-.52zm-2-1l-.25.21c.08-.03.16-.1.23-.18zm-.57.38l-.08-.08c.15-.17.31-.34.46-.52l.08.09zm.69-.24l.4.44-.38.45-.5-.47zm-.15-.55a7.11 7.11 0 0 0 .46-.62c0 .08.09.16.14.23l-.51.5zm.69-.23l-.39.36-.1.09zm.11.18l.27.41-.36.43-.37-.41zm.37.54a5.27 5.27 0 0 0 .43.51c-.08.17-.16.34-.25.51l-.53-.6zm.6 1.81c-.07.22-.15.43-.24.65a3.39 3.39 0 0 0-.33-.42 2.09 2.09 0 0 0-.14-.17c.1-.16.2-.33.29-.5zm-.83-.07c-.21-.24-.43-.46-.66-.68l.37-.44.58.62-.08.14zm-.09.16c-.14.24-.28.47-.43.7l-.43-.51c-.09-.11-.18-.22-.28-.32.15-.2.31-.39.46-.58.21.26.44.5.66.74zm-1.24-.25c-.17-.21-.35-.41-.53-.61l.46-.45.21.19c.1.1.21.2.31.31zm-1.69-.67c-.12-.16-.23-.32-.35-.47.08-.17.17-.33.25-.5.14.15.28.31.43.46zm.48-.35c.07.08.14.15.2.23-.13.15-.27.3-.4.46l-.12-.14zm-.46-.86l.23-.44.52.49-.3.44zm.89.18l.33.3-.38.42-.24-.26zm.44.39l.09.08-.31.42-.07.08-.12-.14c.11-.12.25-.26.39-.41zm.21 1.48c-.1.14-.21.27-.3.41a.44.44 0 0 0-.08.11l-.45-.5-.13-.15c.12-.16.25-.32.38-.47.19.22.38.42.6.63zm-1.07-.26l-.12-.13c.13-.16.27-.32.41-.47l.11.12c0 .06-.11.12-.16.19a2.17 2.17 0 0 0-.26.32zm-.1.13l-.34.48a1.54 1.54 0 0 0-.08-.19 4.56 4.56 0 0 1 .31-.42zm-.48.13v-.12l.21-.38a1.47 1.47 0 0 1 .1.13zm-.15-.41c-.08-.22-.16-.45-.23-.67v-.06c.11.15.23.29.35.44zm-.23-1.07l-.2-.29.17-.45.27.28zm.06-1c.06-.15.11-.31.16-.46l.37.35c-.08.14-.16.28-.23.43zm1.08-1.11c0 .08-.08.16-.13.24l-.34.62-.39-.38.15-.44c.08-.21.15-.43.23-.64zm.11.14l.57.68-.1.13c-.13.18-.26.35-.38.53l-.55-.5c.13-.25.27-.5.41-.75a.41.41 0 0 0 .03-.08zm.6.38l-.49-.56c.16-.26.32-.52.49-.77-.03.45-.03.88-.02 1.34zm.08.43l.35.42c-.14.18-.3.36-.46.54l-.15-.13-.2-.18.4-.56zm.62-1.09l-.51.67v-1.63c.16.31.33.63.51.94zm.36.64a8.12 8.12 0 0 1-.48.67l-.36-.4.57-.75zm.6-1.12a8.12 8.12 0 0 1-.51 1l-.25-.46c.13-.18.27-.35.41-.53l.28-.34c0 .1.02.22.05.34zm.16-.39a1.42 1.42 0 0 1 0-.2l.19-.23zm.1 1.3l-.5.5-.16-.26.15-.24c.11-.21.22-.42.32-.63a6.55 6.55 0 0 0 .17.64zm.08.2c-.15.17-.3.34-.46.5v-.05l.47-.49zm.17-.2c.19-.22.37-.45.55-.68-.2.22-.38.46-.52.69zm.11.76l-.38.46c-.1-.12-.18-.25-.27-.38l.45-.47c.04.15.12.27.18.41zm.36.51l-.26.57c-.13-.16-.27-.32-.39-.49l.37-.45c.07.14.16.26.26.38zm.06-.16c-.07-.12-.13-.25-.2-.38.24-.29.47-.58.7-.88-.18.43-.34.86-.52 1.27zm.26 2.5l-.29-.36c.07-.23.14-.46.19-.7.01.36.07.72.08 1.07zm0 1.07a1.64 1.64 0 0 0 .1-.38c.05.23.14.27-.09.39zm-.34-.11c-.1-.16-.2-.31-.31-.46.1-.22.19-.44.27-.67l.35.36a2.19 2.19 0 0 1 0 .36 1.66 1.66 0 0 1-.18.6s-.06-.08-.12-.18zm-.77.44a2.67 2.67 0 0 0 .12-.24c.09-.15.18-.32.26-.48l.19.28c.06.1.11.23.18.34-.35.32-.57.27-.74.11zm-.13-.13l-.16-.21-.34-.41c.15-.24.28-.49.42-.72a1.27 1.27 0 0 1 .1.12c.13.15.26.31.38.48-.06.13-.13.26-.2.39s-.12.25-.19.36zm-1 .2a7.23 7.23 0 0 0 .44-.64l.43.51.07.09c-.11.19-.12.2-.49.2s-.39.02-.48-.15zm-.31-.48a7.84 7.84 0 0 0-.5-.64l.28-.39.1-.13c.25.27.49.55.73.83l-.12.2-.27.46c-.1-.1-.17-.21-.25-.32zm-1.14.33c.07-.12.13-.24.2-.34l.32-.48.2.24c.19.24.34.5.51.76a.77.77 0 0 1-.22.19.82.82 0 0 1-1-.34zm-.16-.31c-.13-.25-.24-.5-.35-.76l.37-.54.57.68a6.29 6.29 0 0 1-.51.79zm-.75-.08l.3-.51a6.49 6.49 0 0 0 .41.95c-.12.14-.32.15-.61 0a2.34 2.34 0 0 1-.09-.38s-.04-.03-.04-.05zm-.07-.53l.21-.37a.87.87 0 0 1 .07.17l-.26.43zm0-.39l.14-.24v.1l-.23.3a.66.66 0 0 0 0-.15zm0-.43v-.3l.08.2a.47.47 0 0 0-.17.11zm-.26 1.58c.05-.16.1-.31.16-.46v.19c-.07.12-.14.24-.2.36s-.03-.08-.04-.08zm0-.54l.2-.36v.15a4.14 4.14 0 0 0-.19.49 2.46 2.46 0 0 1-.14-.27zm0-1.52l.08-.16c.05.31.07.62.09.93-.06.13-.12.26-.17.39a9.55 9.55 0 0 0 0-1.07zm-.12-.78a1 1 0 0 1 0-.1c0 .15.08.29.11.44l-.06.15c-.12-.16-.14-.32-.18-.48zm-.05-1.23l.24.26c0 .1-.07.2-.11.31-.18-.18-.22-.37-.26-.56zm0 .81v.16a1.24 1.24 0 0 1-.17-.15zm-.08-1.39v-.53l.6.65c0 .15-.11.3-.16.46l-.43-.43zm-.28.16l.12.12v.14l-.06-.12a.43.43 0 0 1 0-.07zm-.14-.45c-.14-.44-.27-.89-.37-1.34a6 6 0 0 0 .46.66c0 .3.09.6.14.9z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M830.27 374.65a6.75 6.75 0 0 0 .25.76h-.19a10.16 10.16 0 0 1-.33-1.07c-.15-.6-.26-1.21-.46-1.8a4.19 4.19 0 0 0-.2-.49c-.08-.18-.15-.52-.26-.12a3.61 3.61 0 0 0-.06.87 20.1 20.1 0 0 1-.07 2.46h-.17c.1-1.06 0-2.14.1-3.21v-.28l.5-.05a3.73 3.73 0 0 1 .36 1c.26.6.35 1.28.53 1.93zM828.25 375.13l-.27-.07a.75.75 0 0 0-.07-.12 13.89 13.89 0 0 1-.7-1.39 6.88 6.88 0 0 0-.54-1.21 8.82 8.82 0 0 0 .32 2.39l-.18-.09a8.61 8.61 0 0 1-.29-2.22l.29-.14a14.46 14.46 0 0 1 1.05 2.17c.14.23.25.45.39.68z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M826.52 372.29a.16.16 0 0 1-.13-.17.18.18 0 0 1 .19-.17.19.19 0 0 1 .19.18v.06l.06.09-.29.14zM831.66 371.58v-.05a.18.18 0 0 1 .2-.18.19.19 0 0 1 .19.19.24.24 0 0 1 0 .08.4.4 0 0 1 .1.12l-.6-.06a.57.57 0 0 1 .11-.1zM829 371.6a.19.19 0 0 1 .23-.25.16.16 0 0 1 .13.12.34.34 0 0 1 0 .1l.09.11-.5.05a.58.58 0 0 1 .05-.13zM834.54 372.17v.17h-.11v-.08a.13.13 0 0 0-.15 0l-.13-.05a1.07 1.07 0 0 1 .16-.14.17.17 0 0 1 .17-.19l.14.06a.17.17 0 0 1-.08.23zM835.42 372.82a.43.43 0 0 0 0-.05.12.12 0 0 1 0-.1.18.18 0 0 1 .35 0 .16.16 0 0 1-.17.16.71.71 0 0 1 0 .14z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M834.41 372.21v.08l-.19-.07a.13.13 0 0 1 .19-.01z"
        style={{
          fill: "url(#s-98a276cdc1-aM)",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M830.84 371.22a11.26 11.26 0 0 1 3.62.62.17.17 0 0 0-.17.19 1.07 1.07 0 0 0-.16.14 10 10 0 0 0-2-.43.4.4 0 0 0-.1-.12.24.24 0 0 0 0-.08.19.19 0 0 0-.19-.19.18.18 0 0 0-.2.18v.05a.57.57 0 0 0-.13.1h-.7a13 13 0 0 0-1.42 0l-.09-.11a.34.34 0 0 0 0-.1.16.16 0 0 0-.13-.12.19.19 0 0 0-.23.25.58.58 0 0 0-.05.14 7.79 7.79 0 0 0-2.1.54l-.06-.09v-.06a.19.19 0 0 0-.19-.18.18.18 0 0 0-.19.17.16.16 0 0 0 .13.17v.13c-.56.3-.88.65-.89 1s.42.86 1.18 1.22l.18.09a8.19 8.19 0 0 0 1 .33l.27.07.53.1h.17q.64.11 1.38.15h.7a11.36 11.36 0 0 0 1.19-.05h.19l.72-.11h.2a7.33 7.33 0 0 0 1.13-.31l.13-.05.28-.12.2-.1a3 3 0 0 0 .32-.2l.2-.17a.93.93 0 0 0 .35-.62 1 1 0 0 0-.34-.67.71.71 0 0 0 0-.14.16.16 0 0 0 .17-.16.18.18 0 0 0-.35 0 .12.12 0 0 0 0 .1.43.43 0 0 1 0 .05 4 4 0 0 0-.86-.48v-.17a.17.17 0 0 0 .06-.27c1.12.44 1.81 1.07 1.79 1.76a1.29 1.29 0 0 1-.48.91 1.37 1.37 0 0 1-.18.16 1.64 1.64 0 0 1-.22.14 1.07 1.07 0 0 1-.21.13 3.52 3.52 0 0 1-.39.18l-.22.1-.19.06-.13.05a7.94 7.94 0 0 1-1 .25h-.38l-.55.07H830a9.91 9.91 0 0 1-1.14-.13h-.31l-.26-.06h-.4l-.43-.12-.18-.06-.15-.05-.21-.09h-.11l-.33-.15a3.48 3.48 0 0 1-.5-.3l-.25-.19a1.44 1.44 0 0 1-.58-1.07c.06-1.39 2.55-2.35 5.69-2.28z"
        style={{
          fill: "url(#s-98a276cdc1-aN)",
        }}
        transform="translate(-114.32 -239.04)"
      />
      <path
        d="M832.36 375.82a.15.15 0 0 1-.13-.26l4.57.07a.18.18 0 0 1 .23 0 .14.14 0 0 1 0 .21l-4.57-.07a.13.13 0 0 1-.1.05z"
        style={{
          fill: "url(#s-98a276cdc1-aO)",
        }}
        transform="translate(-114.32 -239.04)"
      />
    </g>
    <g id="volleyballNet">
      <path
        d="M435.24 139.92V99.63"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2.5px",
          stroke: "url(#s-98a276cdc1-e)",
        }}
      />
      <path
        d="M430.6 120.31l-38.16 51.65"
        style={{
          fill: "none",
          stroke: "#333",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M430.6 109.78l-37.53 48.58M430.6 111.54l-37.53 48.55M430.6 113.17l-37.53 48.7M430.6 114.81l-37.53 48.81M430.66 116.31l-37.59 48.93M430.6 117.74l-37.53 49.22M430.52 119.09l-37.45 49.65"
        style={{
          fill: "none",
          stroke: "#333",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".150000005960464px",
        }}
      />
      <path
        d="M395.07 153.19v15.38M394.4 153.58v15.38M393.57 154.6v15.38M395.72 152.35v15.2M396.41 151.45v15.04M397.12 150.26v15.38M397.76 149.42v15.19M398.46 148.51v15.04M399.21 147.72v15.38M399.86 146.88v15.19M400.56 145.98v15.03M401.26 144.78v15.39M401.9 143.94v15.2M402.6 143.04v15.04M403.32 142.36v15.39M403.97 141.53v15.19M404.66 140.62v15.04M405.37 139.43v15.38M406.01 138.59v15.2M406.71 137.69v15.04M407.35 136.99v15.38M408 136.15v15.2M408.7 135.25v15.04M409.4 134.05v15.39M410.05 133.22v15.19M410.74 132.88v13.9M411.49 132.08v14.25M412.14 131.25v14.06M412.84 130.34v13.9M413.54 129.15v14.25M414.19 128.31v14.06M414.88 127.41v13.9M415.6 126.73v14.25M416.25 125.89v14.06M416.95 124.99v13.9M417.65 123.8v14.24M418.3 122.96v14.06M418.99 122.05v13.91M419.68 121.1v13.91M420.42 120.3v14.25M421.07 119.47v14.06M421.77 118.56v13.91M422.47 117.37v14.25M423.12 116.53v14.06M423.82 115.63v13.9M424.53 114.95v14.25M425.18 114.11v14.06M425.88 113.21v13.9M426.58 112.02v14.24M427.23 111.18v14.06M427.93 110.28v13.9M428.5 109.38v14.24M429.14 108.54v14.06M429.84 107.64v13.9"
        style={{
          fill: "none",
          stroke: "#333",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".150999993085861px",
        }}
      />
      <path
        d="M392.44 156.24l-7.87 9.28M392.57 171.23l-9.43 14.44M392.44 166.05l-7.87 10.82M430.6 107.2l4.76-6.3M430.66 116.31l4.63-5.66M430.66 120.12l4.58-4.97"
        style={{
          fill: "none",
          stroke: "#333",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".5px",
        }}
      />
      <path
        d="M430.6 120.31V107.2l-38.16 49.04v15.27"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "url(#s-98a276cdc1-f)",
        }}
      />
      <path
        d="M384.57 212.84v-50.41"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2.5px",
          stroke: "url(#s-98a276cdc1-aP)",
        }}
      />
    </g>
    <g id="tennisNet">
      <path
        d="M441.48 124.8l-67.55 99.33"
        style={{
          fill: "none",
          stroke: "#fff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M441 123.24l-67.07 98.45M441 121.27l-67.07 98.45M441 119.35l-67.07 98.46M441 117.39l-67.07 98.45M441 115.44l-67.07 98.45M441 113.47l-67.07 98.45M441 111.55l-67.07 98.46M441 109.59l-67.07 98.45M441 107.7l-67.07 98.46M441 105.74l-67.07 98.45M441 103.82l-67.07 98.45M375.9 196.51v24.7M377.09 194.89v24.61M378.37 193.23l-.05 24.45M379.65 191.04l-.04 23.94M380.84 189.51l-.04 23.59M382.12 187.85l-.05 23.31M383.49 185.68l-.04 24.65M384.68 183.35l-.05 25.1M385.96 181.7l-.05 24.8M387.24 179.51v24.78M388.43 177.98v24.43M389.71 176.32v24.15M391.02 174.65l.04 23.94M392.21 172.89l.03 23.82M393.49 171.04l.03 23.73M394.77 169.16l.04 24.05M395.96 167.42l.05 23.05M397.24 164.96l.05 23.57M398.41 163.84l.05 24.04M399.59 162.13l.01 23.93M400.87 160.23v23.94M402.16 158.35v24.34M403.34 156.62l.01 24.33M404.62 154.74v24.34M406 152.06v24.8M407.18 151v24.28M408.46 149.13v24.13M409.74 147.25l.01 24.05M410.93 145.51v24.08M412.21 143.63v23.92M413.53 141.75v23.85M414.71 139.39v24.49M416.04 137.97l-.05 24.08M417.33 135.78l-.06 24.73M418.51 134.25l-.05 24.56M419.74 132.61v24.06M420.99 130.78v24.08M422.36 128.71v24.2M423.55 127.04v24.12M424.83 125.17v23.78M426.11 123.29v24.11M427.3 121.55v23.97M428.58 119.68v23.9M429.89 117.75v24.22M431.08 116.02v24.07M432.36 114.14v24M433.64 112.26v24.33M434.83 110.53v24.18M436.11 108.66v24.11M438.34 105.39v24.48M439.62 103.52v24.41"
        style={{
          fill: "none",
          stroke: "#333",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
        }}
      />
      <path
        d="M379.83 215.48v-24.64"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "url(#s-98a276cdc1-aQ)",
        }}
      />
      <path
        d="M436.94 131.47v-24.03"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "url(#s-98a276cdc1-aR)",
        }}
      />
      <path
        d="M441.48 124.8v-24l-67.55 98.86v24.47"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "url(#s-98a276cdc1-aS)",
        }}
      />
      <path
        d="M373.93 227.38v-27.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2.5px",
          stroke: "url(#s-98a276cdc1-aT)",
        }}
      />
      <path
        d="M441.48 127.18V100.6"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2.5px",
          stroke: "url(#s-98a276cdc1-aU)",
        }}
      />
    </g>
    <g id="unihockey">
      <g id="unihockeyLeft">
        <path
          d="M177.99 166.37l-44.43-2.59 41.57-26.27 40.87 2.72-38.01 26.14z"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M271.73 395.81l-11.92-.76V394l20.86-12.44a3.09 3.09 0 0 1 2-.41l9.51 1.29v1.09l-9.23-.57a3.08 3.08 0 0 0-1.8.44l-16.69 10.12 7.26 1.24z"
          style={{
            fill: "url(#s-98a276cdc1-g)",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M271.58 394.71l-11.77-.71 21-12.5a3 3 0 0 1 1.79-.44l10.11.64-.45.58a.39.39 0 0 1-.33.15l-9.14-.58a3 3 0 0 0-1.79.44l-18.61 11.1 10.4.65-.94.64a.4.4 0 0 1-.27.03z"
          style={{
            fill: "url(#s-98a276cdc1-aV)",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M291.5 362.3a26.14 26.14 0 0 1-5.79-.58v-.11a25.62 25.62 0 0 0 6.24.58v.11zM291.45 361.72a23.72 23.72 0 0 1-5.49-.56v-.1a24.62 24.62 0 0 0 6 .55v.11zM291.55 363.47a27.73 27.73 0 0 1-6.06-.61v-.1a28.76 28.76 0 0 0 6.47.6v.1zM291.54 362.88a27.32 27.32 0 0 1-5.94-.59v-.1a27.81 27.81 0 0 0 6.36.58v.11zM291.47 364.52a28.54 28.54 0 0 1-6.13-.59v-.1a30 30 0 0 0 6.62.58v.1zM291.56 363.94a28.51 28.51 0 0 1-6.16-.62v-.1a28.94 28.94 0 0 0 6.56.6v.11zM291.52 365.68a31.6 31.6 0 0 1-6.47-.61v-.1a32.54 32.54 0 0 0 6.9.6v.11zM291.48 365.1a31 31 0 0 1-6.32-.58v-.11a31.66 31.66 0 0 0 6.84.59v.11zM291.57 366.84a34.8 34.8 0 0 1-6.74-.62v-.11a34.18 34.18 0 0 0 7.13.62v.11zM291.63 366.26a33.14 33.14 0 0 1-6.68-.68v-.1a33.27 33.27 0 0 0 7 .67v.11zM291.42 368a35.11 35.11 0 0 1-6.81-.59v-.1a36.89 36.89 0 0 0 7.35.58v.1zM291.58 367.42a35.18 35.18 0 0 1-6.86-.63v-.11a35.18 35.18 0 0 0 7.24.63v.11zM291.48 369.06a38.64 38.64 0 0 1-7.09-.6v-.11a39.19 39.19 0 0 0 7.57.6v.1zM291.44 368.48a36.32 36.32 0 0 1-6.94-.6v-.1a37.28 37.28 0 0 0 7.46.58v.11zM291.67 370.22a40.39 40.39 0 0 1-7.48-.74v-.1a41.63 41.63 0 0 0 7.77.73v.11zM291.49 369.64a39.88 39.88 0 0 1-7.21-.61v-.11a40.27 40.27 0 0 0 7.68.61v.11zM291.63 370.8a41.5 41.5 0 0 1-7.56-.71v-.1a41.66 41.66 0 0 0 7.89.7v.11zM291.55 372a44.32 44.32 0 0 1-7.72-.64v-.11a44.24 44.24 0 0 0 8.13.64v.11zM291.63 371.38a43.1 43.1 0 0 1-7.67-.71v-.11a42.39 42.39 0 0 0 8 .71v.11zM291.39 373.13a46.82 46.82 0 0 1-7.8-.59v-.11a47.73 47.73 0 0 0 8.41.57v.11zM291.35 372.55a43.88 43.88 0 0 1-7.62-.59v-.1a45.27 45.27 0 0 0 8.23.57v.11zM291.43 374.29a48.53 48.53 0 0 1-8.06-.61v-.1a51.45 51.45 0 0 0 8.6.6v.11zM291.42 373.71a48.26 48.26 0 0 1-7.94-.6V373a48.91 48.91 0 0 0 8.48.6v.11zM291.45 375.34a51.28 51.28 0 0 1-8.29-.62v-.11a52.68 52.68 0 0 0 8.8.62v.11zM291.36 374.76a50.45 50.45 0 0 1-8.09-.58v-.11a51.68 51.68 0 0 0 8.69.58v.11zM291.35 376.5a53 53 0 0 1-8.39-.58v-.11a53.37 53.37 0 0 0 9 .58v.11zM291.59 375.92a52.55 52.55 0 0 1-8.52-.71v-.11a51.93 51.93 0 0 0 8.9.71v.11zM291.3 377.67a56.87 56.87 0 0 1-8.6-.59V377a58.45 58.45 0 0 0 9.27.59v.1zM291.28 377.09a53.81 53.81 0 0 1-8.45-.59v-.1a55.75 55.75 0 0 0 9.17.6v.11zM291.35 378.83a60.39 60.39 0 0 1-8.88-.6v-.11a60.06 60.06 0 0 0 9.49.6v.11zM291.32 378.25a57.11 57.11 0 0 1-8.73-.6v-.11a58.64 58.64 0 0 0 9.38.6v.11zM291.39 379.88a62 62 0 0 1-9.12-.62v-.1a65.45 65.45 0 0 0 9.7.61v.11zM291.37 379.3a61.68 61.68 0 0 1-9-.61v-.11a62.42 62.42 0 0 0 9.58.61v.11zM291.29 381a64.66 64.66 0 0 1-9.26-.58v-.11a65.05 65.05 0 0 0 9.93.58v.11zM291.29 380.46a63.49 63.49 0 0 1-9.14-.58v-.11a64 64 0 0 0 9.82.58v.11z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M168.44 142.38l-.1-.02 3.92-20.77.11.02-3.93 20.77zM169.34 142.38l-.11-.02 3.74-20.84.11.02-3.74 20.84zM176.35 142.92h-.11l.15-21.24h.11l-.15 21.24z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M279.43 371.21h21.2v.11h-21.2z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-89.36 112.003 309.541)"
        />
        <path
          d="M174.84 142.77h-.1l.43-21.1h.11l-.44 21.1zM172.2 142.62l-.11-.01 2.28-21.09.11.01-2.28 21.09z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M278.37 371.13h21v.11h-21z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-88.3 107.42 310.298)"
        />
        <path
          d="M276.46 370.99h21.11v.11h-21.11z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-82.95 94.671 316.192)"
        />
        <path
          d="M275.69 370.95h21.04v.11h-21.04z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-81.33 89.908 318.019)"
        />
        <path
          d="M173.27 142.62l-.11-.01 1.45-21.09.11.01-1.45 21.09z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M282.15 381.47l-.61-.12 3.88-19.74a1.67 1.67 0 0 1 1.74-1.35l5.34.31v.62l-5.34-.31a1.05 1.05 0 0 0-1.09.85z"
          style={{
            fill: "url(#s-98a276cdc1-aW)",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M267.24 366.84h24.01v.08h-24.01z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.96 -209.416 453.783)"
        />
        <path
          d="M263.86 366.82h24.47v.08h-24.47z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.58 -218.26 456.41)"
        />
        <path
          d="M153.91 133.89l-.03-.07 20.53-12.33.03.07-20.53 12.33zM153.23 133.77l-.04-.07 20.27-12.17.04.07-20.27 12.17zM152.24 133.89l-.04-.07 20.61-12.32.04.06-20.61 12.33z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M287.73 359.39h.08v3.27h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-86.86 104.373 301.88)"
        />
        <path
          d="M286.83 360.16h.08v2.79h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-79.7 86.538 310.518)"
        />
        <path
          d="M173.19 123.25l-2.55-.63.02-.08 2.55.63-.02.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M285.57 361.13h.08v2.35h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-68.96 54.425 326.021)"
        />
        <path
          d="M284.95 361.51h.08v2.35h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-68.3 52.924 327.572)"
        />
        <path
          d="M268.99 370.34h.08v4.01h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-85.98 83.676 314.143)"
        />
        <path
          d="M269.76 370.02h.08v3.47h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-84.68 81.449 314.954)"
        />
        <path
          d="M270.66 369.6h.08v3.21h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-81.67 75.237 317.82)"
        />
        <path
          d="M271.49 369.16h.08v3.11h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-80.3 72.682 318.946)"
        />
        <path
          d="M166.48 127.3l-3.04-.43.02-.08 3.04.43-.02.08zM167.38 126.75l-3.01-.43.01-.08 3.01.44-.01.07z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M272.46 368.59h.08v3.09h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-80.34 73.774 318.328)"
        />
        <path
          d="M273.27 368.18h.08v2.94h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78 68.545 320.712)"
        />
        <path
          d="M274.08 367.65h.08v3.04h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-79.91 74.288 317.87)"
        />
        <path
          d="M274.91 367.22h.08v2.91h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78 70.194 319.737)"
        />
        <path
          d="M162.79 129.53l-2.88-.58.02-.08 2.87.58-.01.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M276.53 366.19h.08v3.03h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-80.8 77.406 314.112)"
        />
        <path
          d="M283.79 361.79h.08v3.2h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-80.2 84.388 313.326)"
        />
        <path
          d="M171.29 124.39l-2.45-.71.03-.08 2.44.71-.02.08zM170.19 125.06l-2.76-.54.01-.08 2.77.54-.02.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M282.35 362.82h.08v2.77h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-79.21 80.793 313.765)"
        />
        <path
          d="M281.65 363.25h.08v2.8h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.13 77.302 315.56)"
        />
        <path
          d="M280.98 363.65h.08v2.79h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-77.77 75.66 316.403)"
        />
        <path
          d="M278.6 365h.08v2.94h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-79.64 78.135 315.507)"
        />
        <path
          d="M164.96 128.21l-2.83-.57.01-.07 2.84.57-.02.07z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M277.26 365.89h.08v2.76h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-75.78 66.578 321.205)"
        />
        <path
          d="M259.48 386.56h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -220.683 475.14)"
        />
        <path
          d="M259.5 385.98h24.27v.11H259.5z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -220.66 474.56)"
        />
        <path
          d="M259.66 385.36h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -220.49 473.94)"
        />
        <path
          d="M259.84 384.82h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -220.323 473.4)"
        />
        <path
          d="M259.87 384.24h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -220.282 472.824)"
        />
        <path
          d="M260.03 383.62h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -220.13 472.2)"
        />
        <path
          d="M260.09 383.12h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -220.073 471.707)"
        />
        <path
          d="M260.31 382.6h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -219.85 471.18)"
        />
        <path
          d="M260.34 382.02h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -219.827 470.6)"
        />
        <path
          d="M260.49 381.4h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -219.657 469.98)"
        />
        <path
          d="M260.67 380.86h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -219.49 469.44)"
        />
        <path
          d="M260.7 380.28h24.27v.11H260.7z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -219.449 468.864)"
        />
        <path
          d="M260.86 379.66h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -219.297 468.24)"
        />
        <path
          d="M260.92 379.16h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -219.24 467.746)"
        />
        <path
          d="M261.02 378.59h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -219.144 467.185)"
        />
        <path
          d="M261.05 378.01h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -219.117 466.586)"
        />
        <path
          d="M261.2 377.4h24.27v.11H261.2z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -218.952 465.985)"
        />
        <path
          d="M261.39 376.85h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -218.778 465.426)"
        />
        <path
          d="M261.42 376.27h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -218.738 464.85)"
        />
        <path
          d="M261.57 375.65h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -218.59 464.244)"
        />
        <path
          d="M261.63 375.16h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.7 -218.82 464.56)"
        />
        <path
          d="M261.81 374.49h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -218.349 463.078)"
        />
        <path
          d="M261.97 373.87h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -218.197 462.454)"
        />
        <path
          d="M262.15 373.33h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -218.01 461.918)"
        />
        <path
          d="M262.18 372.74h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -217.983 461.319)"
        />
        <path
          d="M262.33 372.13h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -217.818 460.718)"
        />
        <path
          d="M262.39 371.63h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.7 -218.046 461.026)"
        />
        <path
          d="M262.49 371.06h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.7 -217.951 460.464)"
        />
        <path
          d="M262.52 370.48h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -217.638 459.064)"
        />
        <path
          d="M262.68 369.86h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -217.486 458.44)"
        />
        <path
          d="M262.86 369.32h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -217.3 457.904)"
        />
        <path
          d="M262.89 368.74h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -217.277 457.323)"
        />
        <path
          d="M263.05 368.12h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -217.107 456.704)"
        />
        <path
          d="M263.11 367.62h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -217.05 456.211)"
        />
        <path
          d="M253.59 382.94h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 61.107 333.127)"
        />
        <path
          d="M254.76 382.22h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 62.273 332.401)"
        />
        <path
          d="M254.17 382.6h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 61.684 332.784)"
        />
        <path
          d="M255.28 381.93h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 62.789 332.121)"
        />
        <path
          d="M256.45 381.21h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 63.961 331.4)"
        />
        <path
          d="M255.85 381.6h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 63.366 331.779)"
        />
        <path
          d="M256.96 380.93h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.5 65.525 331.919)"
        />
        <path
          d="M258.13 380.21h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 65.643 330.395)"
        />
        <path
          d="M257.53 380.6h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 65.042 330.78)"
        />
        <path
          d="M258.64 379.93h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 66.153 330.11)"
        />
        <path
          d="M259.81 379.21h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 67.325 329.39)"
        />
        <path
          d="M259.21 379.59h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 66.73 329.778)"
        />
        <path
          d="M260.33 378.98h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 67.84 329.17)"
        />
        <path
          d="M261.49 378.26h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 69.007 328.445)"
        />
        <path
          d="M260.9 378.65h20.58v.11H260.9z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 68.413 328.834)"
        />
        <path
          d="M262.01 377.98h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 69.523 328.165)"
        />
        <path
          d="M263.18 377.26h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 70.689 327.44)"
        />
        <path
          d="M262.58 377.64h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 70.094 327.829)"
        />
        <path
          d="M263.69 376.99h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 71.212 327.175)"
        />
        <path
          d="M264.86 376.27h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 72.378 326.45)"
        />
        <path
          d="M264.27 376.65h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 71.783 326.84)"
        />
        <path
          d="M265.38 375.98h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 72.893 326.17)"
        />
        <path
          d="M266.55 375.26h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 74.06 325.445)"
        />
        <path
          d="M265.95 375.65h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 73.465 325.834)"
        />
        <path
          d="M267.06 374.98h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 74.57 325.17)"
        />
        <path
          d="M268.23 374.26h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 75.736 324.445)"
        />
        <path
          d="M267.63 374.65h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 75.142 324.834)"
        />
        <path
          d="M268.74 373.98h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.5 77.323 324.917)"
        />
        <path
          d="M269.91 373.26h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 77.424 323.444)"
        />
        <path
          d="M269.31 373.64h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 76.824 323.828)"
        />
        <path
          d="M270.42 373.03H291v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 77.934 323.22)"
        />
        <path
          d="M271.59 372.31h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.5 80.182 323.24)"
        />
        <path
          d="M271 372.7h20.58v.11H271z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 78.517 322.883)"
        />
        <path
          d="M272.11 372.03h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 79.622 322.22)"
        />
        <path
          d="M272.68 371.69h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 80.199 321.877)"
        />
        <path
          d="M270.81 374.61A26.14 26.14 0 0 1 265 374v-.11a26.7 26.7 0 0 0 6.24.58v.11zM270.76 374a23.72 23.72 0 0 1-5.49-.56v-.11a24.6 24.6 0 0 0 6 .56v.1zM270.86 375.77a28.37 28.37 0 0 1-6.06-.6v-.11a28.19 28.19 0 0 0 6.47.6v.11zM270.85 375.19a27.32 27.32 0 0 1-5.94-.59v-.11a27.79 27.79 0 0 0 6.36.59v.11zM270.78 376.82a29.2 29.2 0 0 1-6.13-.58v-.11a29.41 29.41 0 0 0 6.62.58v.11zM270.88 376.24a29.34 29.34 0 0 1-6.17-.61v-.11a29.56 29.56 0 0 0 6.56.61v.11zM270.83 378a31.43 31.43 0 0 1-6.46-.61v-.11a32 32 0 0 0 6.9.6v.12zM270.79 377.4a30.34 30.34 0 0 1-6.32-.58v-.11a30.43 30.43 0 0 0 6.79.58v.11zM270.88 379.15a34 34 0 0 1-6.74-.63v-.11a34.85 34.85 0 0 0 7.13.63v.11zM270.94 378.57a33.14 33.14 0 0 1-6.68-.68v-.11a32.64 32.64 0 0 0 7 .68v.1zM270.73 380.31a35.93 35.93 0 0 1-6.81-.58v-.11a36.89 36.89 0 0 0 7.35.58v.11zM270.89 379.73a35.15 35.15 0 0 1-6.86-.64v-.1a35.89 35.89 0 0 0 7.24.63v.11zM270.79 381.36a38.64 38.64 0 0 1-7.09-.6v-.11a38.35 38.35 0 0 0 7.57.6v.11zM270.74 380.78a37.13 37.13 0 0 1-6.93-.59v-.11a37.25 37.25 0 0 0 7.46.59v.11zM271 382.52a41.5 41.5 0 0 1-7.48-.73v-.11a40.15 40.15 0 0 0 7.77.73v.11zM270.8 381.94a39 39 0 0 1-7.21-.61v-.1a39.5 39.5 0 0 0 7.68.6v.11zM270.94 383.11a42.5 42.5 0 0 1-7.56-.71v-.11a42.46 42.46 0 0 0 7.89.71v.1zM270.86 384.27a45.32 45.32 0 0 1-7.72-.64v-.11a45.14 45.14 0 0 0 8.13.64v.11zM270.94 383.69a43.19 43.19 0 0 1-7.67-.71v-.11a43.24 43.24 0 0 0 8 .71v.11zM270.71 385.43a46.86 46.86 0 0 1-7.81-.59v-.11a46.78 46.78 0 0 0 8.37.59v.11zM270.66 384.85a44.91 44.91 0 0 1-7.62-.58v-.11a45.23 45.23 0 0 0 8.23.58v.11zM270.75 386.6a49.67 49.67 0 0 1-8.07-.61v-.11a49.49 49.49 0 0 0 8.6.6v.11zM270.72 386a47.15 47.15 0 0 1-7.93-.6v-.1a49.1 49.1 0 0 0 8.48.59v.11zM270.76 387.65a51.15 51.15 0 0 1-8.29-.63v-.1a52.68 52.68 0 0 0 8.8.62v.1zM270.67 387.06a49.32 49.32 0 0 1-8.09-.58v-.1a50.72 50.72 0 0 0 8.69.57v.11zM270.66 388.81a54.21 54.21 0 0 1-8.39-.58v-.11a55.55 55.55 0 0 0 9 .58v.11zM270.9 388.23a52.59 52.59 0 0 1-8.52-.72v-.1a52.87 52.87 0 0 0 8.9.71v.11zM270.62 390a55.65 55.65 0 0 1-8.61-.59v-.11a57.08 57.08 0 0 0 9.26.59v.11zM270.59 389.39a55.08 55.08 0 0 1-8.45-.58v-.11a56.83 56.83 0 0 0 9.14.58v.11zM270.66 391.14a59 59 0 0 1-8.88-.61v-.11a60.06 60.06 0 0 0 9.49.6v.11zM270.63 390.55a58.55 58.55 0 0 1-8.73-.59v-.11a58.69 58.69 0 0 0 9.38.59v.11zM270.7 392.19a63.37 63.37 0 0 1-9.12-.62v-.11a62.63 62.63 0 0 0 9.69.61v.11zM270.68 391.6a60.31 60.31 0 0 1-9-.61v-.1a61.23 61.23 0 0 0 9.58.6v.11zM270.6 393.35a66.15 66.15 0 0 1-9.26-.58v-.11a67.72 67.72 0 0 0 9.93.58v.11zM270.59 392.77a63.44 63.44 0 0 1-9.13-.58v-.11a66.67 66.67 0 0 0 9.82.58v.11z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M147.75 154.69l-.1-.03 3.92-20.77.11.02-3.93 20.78zM148.65 154.68l-.11-.02 3.74-20.84.11.02-3.74 20.84zM155.66 155.23h-.11l.15-21.25h.11l-.15 21.25z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M258.74 383.51h21.2v.11h-21.2z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-89.4 91.079 321.698)"
        />
        <path
          d="M154.16 155.07h-.11l.43-21.1h.11l-.43 21.1zM151.51 154.92l-.11-.01 2.28-21.08.11.01-2.28 21.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M257.68 383.43h21v.11h-21z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-88.08 87.426 323.078)"
        />
        <path
          d="M255.77 383.3h21.11v.11h-21.11z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-82.95 73.982 328.495)"
        />
        <path
          d="M255 383.26h21.04v.11H255z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-81.33 69.212 330.323)"
        />
        <path
          d="M152.58 154.92l-.11-.01 1.45-21.08.11.01-1.45 21.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M261.31 393.8l-.61-.12 3.88-19.74a1.68 1.68 0 0 1 1.74-1.35l5.34.31v.62l-5.34-.31a1.05 1.05 0 0 0-1.09.85z"
          style={{
            fill: "url(#s-98a276cdc1-aX)",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M271.79 395.65l-1-.4.07-22.07a1.56 1.56 0 0 1 .75-1.33l20.16-12.17a.37.37 0 0 1 .31 0l.75.23a.38.38 0 0 1 .28.38l-.92 23.24-.94-.05v-21.71a.39.39 0 0 0-.59-.33l-18.11 10.94a1.54 1.54 0 0 0-.76 1.33z"
          style={{
            fill: "url(#s-98a276cdc1-aY)",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M272 395.52l-.28.29.06-22.11a1.56 1.56 0 0 1 .76-1.32l20-12.07a.39.39 0 0 1 .59.33v20.63a3.11 3.11 0 0 1-.91 2.2v-21.2a.39.39 0 0 0-.59-.33l-18.15 10.96a1.55 1.55 0 0 0-.75 1.33v19.54a2.49 2.49 0 0 1-.73 1.75z"
          style={{
            fill: "url(#s-98a276cdc1-aZ)",
          }}
          transform="translate(-114.32 -239.04)"
        />
      </g>
      <g id="unihockeyRight">
        <path
          d="M717.76 203.93l-50.84-3.3-4.08-32.27 45.55 2.71 9.37 32.86z"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M705.79 195.86l10.95.63v-1l-6.54-19.46-9.71.21v1l8.5.48 5.45 17.04-8.65.1v1z"
          style={{
            fill: "url(#s-98a276cdc1-ba)",
          }}
        />
        <path
          d="M705.8 194.86l10.94.63-6.54-19.46-10.16-.47.53.68 9.02.51 5.87 18.07-9.86-.57.2.61z"
          style={{
            fill: "url(#s-98a276cdc1-bb)",
          }}
        />
        <path
          d="M824.05 416.07c-1 0-2.07 0-3.28-.13v-.1a35.33 35.33 0 0 0 7-.08v.1a33.89 33.89 0 0 1-3.72.21zM824 415.55c-1 0-2-.05-3.19-.14v-.1a33.3 33.3 0 0 0 6.73-.07v.1a31.81 31.81 0 0 1-3.54.21zM824 417.12c-1.06 0-2.17 0-3.36-.13v-.1a38.74 38.74 0 0 0 7.26-.08v.1a36 36 0 0 1-3.9.21zM824 416.6c-1 0-2.13-.05-3.32-.13v-.1a38.2 38.2 0 0 0 7.13-.08v.1a35 35 0 0 1-3.81.21zM824.21 418.09c-1.11 0-2.28 0-3.62-.15v-.1a40.73 40.73 0 0 0 7.43 0v.1c-1.31.06-2.52.15-3.81.15zM824 417.55c-1.09 0-2.21-.05-3.4-.13v-.1a40.71 40.71 0 0 0 7.36-.08v.1a37.06 37.06 0 0 1-3.96.21zM824.25 419.14c-1.19 0-2.42-.05-3.75-.14v-.1a44.15 44.15 0 0 0 7.74 0v.1c-1.31.08-2.62.14-3.99.14zM824.36 418.62c-1.18 0-2.43-.05-3.81-.15v-.1a42.85 42.85 0 0 0 7.63 0v.1a37.35 37.35 0 0 1-3.82.15zM824.25 420.19c-1.24 0-2.53 0-3.84-.14V420a47.2 47.2 0 0 0 8-.05v.1c-1.31.08-2.71.14-4.16.14zM823.78 419.65c-1.1 0-2.2 0-3.32-.13v-.1a45 45 0 0 0 7.87-.1v.1c-1.56.15-3.06.23-4.55.23zM824.63 421.28c-1.33 0-2.71-.06-4.31-.18v-.1a50.24 50.24 0 0 0 8.23 0v.1c-1.35.12-2.61.18-3.92.18zM824.25 420.72c-1.27 0-2.57-.05-3.89-.14v-.1a48.69 48.69 0 0 0 8.13-.06v.1c-1.32.13-2.75.2-4.24.2zM824.67 422.23c-1.4 0-2.85-.06-4.43-.17V422a54.61 54.61 0 0 0 8.49 0v.1c-1.35.07-2.68.13-4.06.13zM824.65 421.7c-1.35 0-2.76-.06-4.37-.17v-.1a50.65 50.65 0 0 0 8.36 0v.1c-1.35.12-2.64.17-3.99.17zM823.72 423.24c-1.11 0-2.31 0-3.58-.13V423a56.28 56.28 0 0 0 8.72-.1v.1c-1.4.12-3.14.24-5.14.24zM824.69 422.75c-1.43 0-2.91-.05-4.5-.17v-.1a55 55 0 0 0 8.61 0v.1c-1.34.12-2.7.17-4.11.17zM824 423.77c-1.32 0-2.61 0-3.9-.13v-.1a58.32 58.32 0 0 0 8.85-.07v.09c-1.69.15-3.34.21-4.95.21zM824.76 424.86c-1.55 0-3.16-.06-4.75-.17v-.1a60.28 60.28 0 0 0 9.12 0v.1c-1.35.12-2.83.17-4.37.17zM824.05 424.3c-1.35 0-2.69 0-4-.14v-.1a58.65 58.65 0 0 0 9-.06v.1c-1.68.13-3.35.2-5 .2zM825.24 426c-1.66 0-3.39-.07-5.32-.21v-.1a65.69 65.69 0 0 0 9.38.07v.1c-1.37.04-2.7.14-4.06.14zM825.17 425.42c-1.6 0-3.26-.07-5.21-.2v-.1a62 62 0 0 0 9.22.06v.1c-1.38.1-2.67.14-4.01.14zM825.31 427c-1.74 0-3.54-.07-5.49-.2v-.1a69.23 69.23 0 0 0 9.63.07v.1c-1.35.13-2.72.13-4.14.13zM825.27 426.48c-1.7 0-3.46-.07-5.4-.21v-.1a67.38 67.38 0 0 0 9.5.07v.1c-1.37.09-2.7.14-4.1.14zM825.55 428c-1.66 0-3.38-.07-5.32-.21v-.1a65.55 65.55 0 0 0 9.37.07v.1c-1.36.05-2.69.14-4.05.14zM825.64 427.45c-1.8 0-3.73-.08-5.85-.23v-.1a68.31 68.31 0 0 0 9.74.1v.1c-1.25.09-2.53.13-3.89.13zM826.09 429.05c-1.73 0-3.59-.08-5.82-.24v-.1a64.73 64.73 0 0 0 9.46.11v.1c-1.2.08-2.39.13-3.64.13zM824.83 428.45c-1.51 0-3-.06-4.6-.17v-.1a66.11 66.11 0 0 0 9.44 0v.1c-1.74.11-3.3.17-4.84.17zM826.11 430.11c-1.68 0-3.36-.08-5.66-.24v-.1a67.74 67.74 0 0 0 9.49.12v.1c-1.42.08-2.62.12-3.83.12zM826 429.58c-1.64 0-3.28-.08-5.58-.24v-.1a64.86 64.86 0 0 0 9.39.12v.1c-1.4.08-2.59.12-3.81.12zM825.58 431.19c-1.56 0-3.21-.06-5.27-.21v-.1a68.45 68.45 0 0 0 9.78.07v.1c-1.61.08-3.02.14-4.51.14zM826.16 430.63c-1.74 0-3.49-.08-5.79-.24v-.1a68.4 68.4 0 0 0 9.64.13v.1c-1.39.07-2.61.11-3.85.11zM825.66 432.14c-1.62 0-3.35-.06-5.43-.21v-.1a71.76 71.76 0 0 0 10 .07v.1c-1.57.09-3.03.14-4.57.14zM825.62 431.61c-1.59 0-3.27-.06-5.35-.2v-.1a71.44 71.44 0 0 0 9.89.06v.1c-1.6.09-3.03.14-4.54.14zM826.22 433.22c-1.92 0-3.86-.08-6.08-.23v-.1a77.25 77.25 0 0 0 10.28.11v.1c-1.42.08-2.82.12-4.2.12zM826.09 432.69c-1.86 0-3.73-.08-5.91-.23v-.1a75.18 75.18 0 0 0 10.15.11v.1c-1.49.08-2.86.12-4.24.12z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M715.27 195.11l-2.3-19.23.1-.02 2.3 19.23-.1.02z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M827.62 414.72h.1v19.56h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-5.8 -1589.277 1433.102)"
        />
        <path
          d="M706.78 194.66h-.1l.08-19.18h.1l-.08 19.18zM707.44 194.64h-.1l.09-19.08h.1l-.09 19.08zM708.17 194.77h-.1l.14-19.21h.1l-.14 19.21z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M825.08 414.68h.1v19.19h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-1.57 -7954.546 4476.705)"
        />
        <path
          d="M709.04 175.56h.1v19.28h-.1z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M825.79 414.7h.1v19.33h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-2.39 -4960.019 3045.36)"
        />
        <path
          d="M826.75 414.72h.1v19.48h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-4.12 -2553.587 1893.796)"
        />
        <path
          d="M824.2 414.6h.1v19.3h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.81 -16143.682 8389.286)"
        />
        <path
          d="M817.61 397.47c-.7 0-1.44 0-2.25-.08v-.1a29.16 29.16 0 0 0 6.2-.21v.1a27.91 27.91 0 0 1-3.95.29zM817.63 397c-.68 0-1.41 0-2.24-.08v-.1a26.22 26.22 0 0 0 6-.21v.1a24.3 24.3 0 0 1-3.76.29zM817.55 398.51c-.72 0-1.46 0-2.25-.07v-.1a30.61 30.61 0 0 0 6.43-.23v.1a28.7 28.7 0 0 1-4.18.3zM817.57 398c-.71 0-1.45 0-2.24-.07v-.1a30.25 30.25 0 0 0 6.32-.22v.09a27.64 27.64 0 0 1-4.08.3zM817.73 399.46c-.78 0-1.59 0-2.49-.08v-.1a32 32 0 0 0 6.57-.2v.1a30 30 0 0 1-4.08.28zM817.53 398.93c-.73 0-1.48 0-2.26-.07v-.1a31.48 31.48 0 0 0 6.52-.23v.1a29.75 29.75 0 0 1-4.26.3zM817.68 400.5c-.79 0-1.62 0-2.5-.08v-.1a34.82 34.82 0 0 0 6.85-.2v.09a31.49 31.49 0 0 1-4.35.29zM817.8 400c-.81 0-1.66 0-2.59-.08v-.1a34.22 34.22 0 0 0 6.74-.19v.1a31.57 31.57 0 0 1-4.15.27zM817.61 401.54c-.81 0-1.64 0-2.49-.07v-.1a38 38 0 0 0 7.08-.22v.1a35.52 35.52 0 0 1-4.59.29zM817.29 401c-.71 0-1.42 0-2.14-.07v-.1a35.35 35.35 0 0 0 7-.26v.1a36.57 36.57 0 0 1-4.86.33zM818 402.6c-.91 0-1.87 0-2.94-.09v-.1a39.61 39.61 0 0 0 7.3-.17v.1a35.7 35.7 0 0 1-4.36.26zM817.59 402.06c-.82 0-1.66 0-2.5-.07v-.1a39.16 39.16 0 0 0 7.19-.22v.1a36.88 36.88 0 0 1-4.69.29zM818 403.54c-.94 0-1.92 0-3-.09v-.1a41.94 41.94 0 0 0 7.51-.17v.1a40.24 40.24 0 0 1-4.51.26zM818 403c-.93 0-1.9 0-3-.09v-.1a40.71 40.71 0 0 0 7.4-.17v.1a36.77 36.77 0 0 1-4.4.26zM817.17 404.56c-.71 0-1.46 0-2.23-.07v-.1a43.65 43.65 0 0 0 7.73-.28v.1a47.25 47.25 0 0 1-5.5.35zM818 404.06c-1 0-1.94 0-3-.09v-.1a43.31 43.31 0 0 0 7.63-.17v.1a41.44 41.44 0 0 1-4.63.26zM817.35 405.08c-.82 0-1.63 0-2.44-.07v-.09a45.27 45.27 0 0 0 7.84-.26v.1a45.84 45.84 0 0 1-5.4.32zM817.87 406.14c-1 0-2 0-3-.08V406a49.51 49.51 0 0 0 8.07-.18v.1a47.3 47.3 0 0 1-5.07.22zM817.37 405.61c-.84 0-1.67 0-2.49-.07v-.1a47.39 47.39 0 0 0 8-.25v.1a48.31 48.31 0 0 1-5.51.32zM818.36 407.21c-1.12 0-2.3 0-3.58-.11v-.1a51.61 51.61 0 0 0 8.31-.12v.1c-1.58.15-3.09.23-4.73.23zM818.37 406.69c-1.1 0-2.25 0-3.56-.11v-.1a49.86 49.86 0 0 0 8.17-.12v.1c-1.59.15-3.04.23-4.61.23zM818.35 408.25c-1.16 0-2.36 0-3.63-.11V408a54.38 54.38 0 0 0 8.53-.12v.1c-1.59.19-3.2.27-4.9.27zM818.35 407.73c-1.14 0-2.32 0-3.6-.11v-.1a53 53 0 0 0 8.42-.12v.1a50.7 50.7 0 0 1-4.82.23zM818.35 409.19c-1.19 0-2.41 0-3.68-.1V409a58.19 58.19 0 0 0 8.73-.13v.1c-1.61.14-3.29.22-5.05.22zM818.64 408.68c-1.24 0-2.54 0-3.94-.12v-.1a55.37 55.37 0 0 0 8.63-.09v.1c-1.48.14-3.02.21-4.69.21zM818.81 410.25c-1.32 0-2.73 0-4.21-.12V410a59 59 0 0 0 8.93-.09v.1q-2.14.24-4.72.24zM817.67 409.69c-1 0-2 0-3-.08v-.1a57.26 57.26 0 0 0 8.83-.21v.1a58.09 58.09 0 0 1-5.83.29zM818.82 411.3c-1.33 0-2.72 0-4.28-.13v-.1a62 62 0 0 0 9.19-.08v.1c-1.67.14-3.24.21-4.91.21zM818.81 410.78c-1.31 0-2.68 0-4.24-.13v-.1a60.2 60.2 0 0 0 9.06-.08v.1c-1.63.14-3.19.21-4.82.21zM818.83 412.34c-1.38 0-2.8 0-4.35-.13v-.09a66.37 66.37 0 0 0 9.41-.09v.1c-1.67.14-3.32.21-5.06.21zM818.82 411.82c-1.35 0-2.76 0-4.31-.13v-.1a63.47 63.47 0 0 0 9.3-.08v.1c-1.67.14-3.28.21-4.99.21zM818.83 413.28c-1.42 0-2.88 0-4.41-.12v-.1a69.38 69.38 0 0 0 9.62-.09v.1c-1.67.14-3.4.21-5.21.21zM818.82 412.76c-1.39 0-2.83 0-4.36-.12v-.1a67.79 67.79 0 0 0 9.51-.09v.1c-1.68.14-3.37.21-5.15.21zM819.34 414.35q-2.34 0-5-.15v-.1a72.61 72.61 0 0 0 9.85 0v.1c-1.45.08-3.09.15-4.85.15zM819.27 413.82c-1.53 0-3.14-.05-4.88-.14v-.1a70.77 70.77 0 0 0 9.73-.05v.1c-1.5.13-3.12.19-4.85.19z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M822.3 396.17h.1v19.11h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-7.17 -1142.442 1198.556)"
        />
        <path
          d="M821.58 396.06h.1v19.31h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-6.26 -1421.835 1331.177)"
        />
        <path
          d="M701.3 176.05l-.02-19.11h.1l.02 19.11h-.1z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M816.3 396.08h.1v18.95h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.13 -104569.494 50680.733)"
        />
        <path
          d="M817.06 396.08h.1v18.94h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.31 -43432.883 21409.186)"
        />
        <path
          d="M705.42 175.97l-.82-18.94h.1l.82 18.94h-.1z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M817.86 396.08h.1v18.99h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.75 -17500.361 9018.667)"
        />
        <path
          d="M819.95 396.07h.1v19.1h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-3.2 -3516.15 2332.39)"
        />
        <path
          d="M820.81 396.07h.1v19.24h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-4.75 -2118.455 1664.137)"
        />
        <path
          d="M818.6 395.98h.1v19.09h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-1.41 -8952.977 4930.337)"
        />
        <path
          d="M823.92 415.43l-2.19-18.13c-.07-.79-.94-.93-1.66-.91l-6-.2v-.57l6 .2c1.89-.05 2.19 1 2.23 1.42l2.19 18.12z"
          style={{
            fill: "url(#s-98a276cdc1-bc)",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M824.63 416.76l-2.19-18.13a1.32 1.32 0 0 0-1.25-1.19l-6-.19v-.1l6 .19a1.43 1.43 0 0 1 1.34 1.28l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M825.09 418.05l-2.19-18.14a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.34 1.27l2.19 18.1z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M825.6 419.65l-2.2-18.13a1.3 1.3 0 0 0-1.24-1.18l-6-.2V400l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M826.05 420.8l-2.19-18.13a1.31 1.31 0 0 0-1.25-1.19l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.33 1.27l2.2 18.14z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M826.51 422.14L824.32 404a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.19 18.14z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M827 423.48l-2.19-18.13a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M827.48 425.1l-2.19-18.1a1.33 1.33 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.43 1.43 0 0 1 1.34 1.28l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M828 426.52l-2.2-18.14a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.33 1.27l2.19 18.14z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M828.44 428l-2.19-18.13a1.31 1.31 0 0 0-1.25-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M828.92 429.39l-2.2-18.13a1.3 1.3 0 0 0-1.24-1.19l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.33 1.28l2.2 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M829.43 431.13l-2.2-18.13a1.31 1.31 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.42 1.42 0 0 1 1.33 1.28l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M829.9 432.46l-2.2-18.13a1.31 1.31 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.42 1.42 0 0 1 1.33 1.28l2.21 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M830.16 434.07L828 415.93a1.07 1.07 0 0 0-1-1l-6.38-.2v-.57l6.39.2a1.64 1.64 0 0 1 1.56 1.48l2.2 18.13z"
          style={{
            fill: "url(#s-98a276cdc1-bd)",
          }}
          transform="translate(-114.32 -239.04)"
        />
        <path
          d="M818.56 395.44h.1v19.33h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-17.86 .62 649.283)"
        />
        <path
          d="M819.71 395.55h.1v19.37h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-17.47 -15.316 657.726)"
        />
        <path
          d="M709.38 175.57l-5.71-18.56.1-.03 5.7 18.57-.09.02zM710.67 175.58l-6.09-18.62.1-.03 6.09 18.61-.1.04zM711.73 175.58l-6.3-18.52.09-.03 6.31 18.51-.1.04z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M824.01 395.7h.1v19.52h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-18.69 40.797 633.306)"
        />
        <path
          d="M820.32 435.1a.58.58 0 0 1-.58-.57v-20.11L815 399.69v16.46a.58.58 0 0 1-.57.57.57.57 0 0 1-.57-.57V396a.57.57 0 0 1 1.11-.17l5.83 18.21a.48.48 0 0 1 .06.24v20.22a.58.58 0 0 1-.54.6z"
          style={{
            fill: "url(#s-98a276cdc1-be)",
          }}
          transform="translate(-114.32 -239.04)"
        />
      </g>
    </g>
  </Fragment>
);

const defaultProps = {
  children,
  viewBox,
  fillColor: null,
  fillColorRule: "&&& path, &&& use, &&& g",
  size: null,
};

const propTypes = {
  fillColor: PropTypes.string,
  fillColorRule: PropTypes.string,
  viewBox: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired,
    }),
  ]),
  sizes: (props, name, componentName) => {
    const prop = props[name];
    if (typeof prop !== "object") {
      return;
    }
    for (let key in prop) {
      if (
        !prop[key] ||
        typeof prop[key].width !== "number" ||
        typeof prop[key].height !== "number"
      ) {
        return new Error(
          "Invalid prop `" +
            name +
            "` supplied to `" +
            componentName +
            "`. Validation failed."
        );
      }
    }
  },
};

export default Object.assign(Image, {
  getDimensions,
  getCss,
  defaultProps,
  propTypes,
  displayName: "28x15",
});
